// Gallery data for each section
// Updated with actual local images

export const galleryData = {
  apple: [
    {
      src: '/images/galleries/apple/southington_town_seal.png',
      alt: 'Southington Town Seal',
      caption: 'Southington Town Seal'
    },
    {
      src: '/images/galleries/apple/southington_snow.jpg',
      alt: 'Southington in winter',
      caption: 'Southington covered in snow during winter storm Jan 2013'
    },
    {
      src: '/images/galleries/apple/southington_flood.jpg',
      alt: 'Southington flood',
      caption: 'Flooded Dog Park in Southington'
    },
    {
      src: '/images/galleries/apple/southington.jpg',
      alt: 'Southington, CT',
      caption: 'Ciao'
    },
    {
      src: '/images/galleries/apple/ILoveSouthington.jpg',
      alt: 'apple photo - ILoveSouthington.jpg',
      caption: 'apple photo - ILoveSouthington.jpg'
    },
    {
      src: '/images/galleries/apple/southington.jpg',
      alt: 'apple photo - southington.jpg',
      caption: 'apple photo - southington.jpg'
    },
    {
      src: '/images/galleries/apple/southington_flood.jpg',
      alt: 'apple photo - southington_flood.jpg',
      caption: 'apple photo - southington_flood.jpg'
    },
    {
      src: '/images/galleries/apple/southington_snow.jpg',
      alt: 'apple photo - southington_snow.jpg',
      caption: 'apple photo - southington_snow.jpg'
    },
    {
      src: '/images/galleries/apple/southington_town_seal.png',
      alt: 'apple photo - southington_town_seal.png',
      caption: 'apple photo - southington_town_seal.png'
    }
  ],
  
  futbol: [
    {
      src: '/images/galleries/futbol/futbol_marco.jpg',
      alt: 'Marco playing football',
      caption: 'Marco - Memorial Day 2025 Tournament Champions'
    },
    {
      src: '/images/galleries/futbol/futbol_maximiliano.jpg',
      alt: 'Maximiliano playing football',
      caption: 'Maximiliano in training at Day Hill Dome'
    },
    {
      src: '/images/galleries/futbol/futbol_marco_max.jpg',
      alt: 'Marco and Max together',
      caption: 'Marco and Max first Hartford Atheltic Tournament'
    },
    {
      src: '/images/galleries/futbol/futbol_marco_trophy.jpg',
      alt: 'Marco with trophy',
      caption: 'Marco - Winter Fustal Tournament Winner'
    },
    {
      src: '/images/galleries/futbol/futbol_azzurri.jpg',
      alt: 'Azzurri team',
      caption: 'The Azzurri fans'
    },
    {
      src: '/images/galleries/futbol/90Plus.jpg',
      alt: 'futbol photo - 90Plus.jpg',
      caption: 'futbol photo - 90Plus.jpg'
    },
    {
      src: '/images/galleries/futbol/Marco-HartfordAthletic.jpg',
      alt: 'futbol photo - Marco-HartfordAthletic.jpg',
      caption: 'futbol photo - Marco-HartfordAthletic.jpg'
    },
    {
      src: '/images/galleries/futbol/Marco_CoachRoby_1.jpg',
      alt: 'futbol photo - Marco_CoachRoby_1.jpg',
      caption: 'futbol photo - Marco_CoachRoby_1.jpg'
    },
    {
      src: '/images/galleries/futbol/MaxWorldCup.gif',
      alt: 'futbol photo - MaxWorldCup.gif',
      caption: 'futbol photo - MaxWorldCup.gif'
    },
    {
      src: '/images/galleries/futbol/futbol_azzurri.jpg',
      alt: 'futbol photo - futbol_azzurri.jpg',
      caption: 'futbol photo - futbol_azzurri.jpg'
    },
    {
      src: '/images/galleries/futbol/futbol_marco.jpg',
      alt: 'futbol photo - futbol_marco.jpg',
      caption: 'futbol photo - futbol_marco.jpg'
    },
    {
      src: '/images/galleries/futbol/futbol_marco_max.jpg',
      alt: 'futbol photo - futbol_marco_max.jpg',
      caption: 'futbol photo - futbol_marco_max.jpg'
    },
    {
      src: '/images/galleries/futbol/futbol_marco_trophy.jpg',
      alt: 'futbol photo - futbol_marco_trophy.jpg',
      caption: 'futbol photo - futbol_marco_trophy.jpg'
    },
    {
      src: '/images/galleries/futbol/futbol_maximiliano.jpg',
      alt: 'futbol photo - futbol_maximiliano.jpg',
      caption: 'futbol photo - futbol_maximiliano.jpg'
    }
  ],
  
  rossetti: [
    {
      src: '/images/galleries/rossetti/castel_campagano_right.jpg',
      alt: 'Castel Campagnano',
      caption: 'Castel Campagnano  - Cherub Flute'
    },
    {
      src: '/images/galleries/rossetti/Rossetti_Giuseppe.jpg',
      alt: 'Giuseppe Rossetti',
      caption: 'Giuseppe Rossetti, 1891–1929'
    },
    {
      src: '/images/galleries/rossetti/Brino_Battista-Paolo.jpg',
      alt: 'Battista Paolo Brino',
      caption: 'Battista Paolo Brino'
    },
    {
      src: '/images/galleries/rossetti/Carbone_Francesco.jpg',
      alt: 'Francesco Carbone',
      caption: 'Francesco Carbone'
    },
    {
      src: '/images/galleries/rossetti/Carolina_Mattarazzo-Rossetti.jpg',
      alt: 'Carolina Mattarazzo Rossetti',
      caption: 'Carolina Mattarazzo Rossetti'
    },
    {
      src: '/images/galleries/rossetti/Castaldo_Giovanna-Rossetti.jpg',
      alt: 'Giovanna Castaldo Rossetti',
      caption: 'Giovanna Castaldo Rossetti'
    },
    {
      src: '/images/galleries/rossetti/DelBouno_Guido.jpg',
      alt: 'Guido DelBouno',
      caption: 'Guido DelBouno'
    },
    {
      src: '/images/galleries/rossetti/Giovannina_Rossetti.jpg',
      alt: 'Giovannina Rossetti',
      caption: 'Giovannina Rossetti'
    },
    {
      src: '/images/galleries/rossetti/Marco_Rossetti.jpg',
      alt: 'Marco Rossetti',
      caption: 'Marco Rossetti'
    },
    {
      src: '/images/galleries/rossetti/Pasquale_Rossetti.jpg',
      alt: 'Pasquale Rossetti',
      caption: 'Pasquale Rossetti'
    },
    {
      src: '/images/galleries/rossetti/Picone_Neil.jpg',
      alt: 'Neil Picone',
      caption: 'Neil Picone'
    },
    {
      src: '/images/galleries/rossetti/Testa_Antonio.jpg',
      alt: 'Antonio Testa',
      caption: 'Antonio Testa'
    },
    {
      src: '/images/galleries/rossetti/Thomas_Eric.jpg',
      alt: 'Eric Thomas',
      caption: 'Eric Thomas'
    },
    {
      src: '/images/galleries/rossetti/castel_campagano_left.jpg',
      alt: 'Castel Campagnano',
      caption: 'Castel Campagnano  - Cherub Guitar'
    },
    {
      src: '/images/galleries/rossetti/Brino_Battista-Paolo.jpg',
      alt: 'rossetti photo - Brino_Battista-Paolo.jpg',
      caption: 'rossetti photo - Brino_Battista-Paolo.jpg'
    },
    {
      src: '/images/galleries/rossetti/Carbone_Francesco.jpg',
      alt: 'rossetti photo - Carbone_Francesco.jpg',
      caption: 'rossetti photo - Carbone_Francesco.jpg'
    },
    {
      src: '/images/galleries/rossetti/Carolina_Mattarazzo-Rossetti.jpg',
      alt: 'rossetti photo - Carolina_Mattarazzo-Rossetti.jpg',
      caption: 'rossetti photo - Carolina_Mattarazzo-Rossetti.jpg'
    },
    {
      src: '/images/galleries/rossetti/Castaldo_Giovanna-Rossetti.jpg',
      alt: 'rossetti photo - Castaldo_Giovanna-Rossetti.jpg',
      caption: 'rossetti photo - Castaldo_Giovanna-Rossetti.jpg'
    },
    {
      src: '/images/galleries/rossetti/DelBouno_Guido.jpg',
      alt: 'rossetti photo - DelBouno_Guido.jpg',
      caption: 'rossetti photo - DelBouno_Guido.jpg'
    },
    {
      src: '/images/galleries/rossetti/Giovannina_Rossetti.jpg',
      alt: 'rossetti photo - Giovannina_Rossetti.jpg',
      caption: 'rossetti photo - Giovannina_Rossetti.jpg'
    },
    {
      src: '/images/galleries/rossetti/IMG_20180627_0003.jpg',
      alt: 'rossetti photo - IMG_20180627_0003.jpg',
      caption: 'rossetti photo - IMG_20180627_0003.jpg'
    },
    {
      src: '/images/galleries/rossetti/IMG_20180627_0004.jpg',
      alt: 'rossetti photo - IMG_20180627_0004.jpg',
      caption: 'rossetti photo - IMG_20180627_0004.jpg'
    },
    {
      src: '/images/galleries/rossetti/IMG_20180627_0005.jpg',
      alt: 'rossetti photo - IMG_20180627_0005.jpg',
      caption: 'rossetti photo - IMG_20180627_0005.jpg'
    },
    {
      src: '/images/galleries/rossetti/IMG_20180627_0006.jpg',
      alt: 'rossetti photo - IMG_20180627_0006.jpg',
      caption: 'rossetti photo - IMG_20180627_0006.jpg'
    },
    {
      src: '/images/galleries/rossetti/IMG_20180627_0008.jpg',
      alt: 'rossetti photo - IMG_20180627_0008.jpg',
      caption: 'rossetti photo - IMG_20180627_0008.jpg'
    },
    {
      src: '/images/galleries/rossetti/Marco',
      alt: 'rossetti photo - Marco',
      caption: 'rossetti photo - Marco'
    },
    {
      src: '/images/galleries/rossetti/Marco_Rossetti.jpg',
      alt: 'rossetti photo - Marco_Rossetti.jpg',
      caption: 'rossetti photo - Marco_Rossetti.jpg'
    },
    {
      src: '/images/galleries/rossetti/Pasquale_Rossetti.jpg',
      alt: 'rossetti photo - Pasquale_Rossetti.jpg',
      caption: 'rossetti photo - Pasquale_Rossetti.jpg'
    },
    {
      src: '/images/galleries/rossetti/Picone_Neil.jpg',
      alt: 'rossetti photo - Picone_Neil.jpg',
      caption: 'rossetti photo - Picone_Neil.jpg'
    },
    {
      src: '/images/galleries/rossetti/Rossetti_Giuseppe.jpg',
      alt: 'rossetti photo - Rossetti_Giuseppe.jpg',
      caption: 'rossetti photo - Rossetti_Giuseppe.jpg'
    },
    {
      src: '/images/galleries/rossetti/Testa_Antonio.jpg',
      alt: 'rossetti photo - Testa_Antonio.jpg',
      caption: 'rossetti photo - Testa_Antonio.jpg'
    },
    {
      src: '/images/galleries/rossetti/Thomas_Eric.jpg',
      alt: 'rossetti photo - Thomas_Eric.jpg',
      caption: 'rossetti photo - Thomas_Eric.jpg'
    },
    {
      src: '/images/galleries/rossetti/castel_campagano_left.jpg',
      alt: 'rossetti photo - castel_campagano_left.jpg',
      caption: 'rossetti photo - castel_campagano_left.jpg'
    },
    {
      src: '/images/galleries/rossetti/castel_campagano_right.jpg',
      alt: 'rossetti photo - castel_campagano_right.jpg',
      caption: 'rossetti photo - castel_campagano_right.jpg'
    },
    {
      src: '/images/galleries/rossetti/rossetti-southington-town-green.jpg',
      alt: 'rossetti photo - rossetti-southington-town-green.jpg',
      caption: 'rossetti photo - rossetti-southington-town-green.jpg'
    }
  ],
  
  pane: [
    {
      src: '/images/galleries/pane/san_cocho.jpg',
      alt: 'pane photo - san_cocho.jpg',
      caption: 'pane photo - san_cocho.jpg'
    }
  ],
  
  wedding: [
    {
      src: '/images/galleries/wedding/GiuseppinaRossetti_PasqualeDeMarco.jpg',
      alt: 'Giuseppina Rossetti & Pasquale DeMarco',
      caption: 'Newlyweds - 1969'
    },
    {
      src: '/images/galleries/wedding/IMG_0640.JPG',
      alt: 'wedding photo - IMG_0640.JPG',
      caption: 'wedding photo - IMG_0640.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0641.JPG',
      alt: 'Wedding celebration photo',
      caption: 'Wedding celebration'
    },
    {
      src: '/images/galleries/wedding/IMG_0642.JPG',
      alt: 'wedding photo - IMG_0642.JPG',
      caption: 'wedding photo - IMG_0642.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0643.JPG',
      alt: 'wedding photo - IMG_0643.JPG',
      caption: 'wedding photo - IMG_0643.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0644.JPG',
      alt: 'wedding photo - IMG_0644.JPG',
      caption: 'wedding photo - IMG_0644.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0645.JPG',
      alt: 'wedding photo - IMG_0645.JPG',
      caption: 'wedding photo - IMG_0645.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0646.JPG',
      alt: 'wedding photo - IMG_0646.JPG',
      caption: 'wedding photo - IMG_0646.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0647.JPG',
      alt: 'wedding photo - IMG_0647.JPG',
      caption: 'wedding photo - IMG_0647.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0648.JPG',
      alt: 'wedding photo - IMG_0648.JPG',
      caption: 'wedding photo - IMG_0648.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0649.JPG',
      alt: 'wedding photo - IMG_0649.JPG',
      caption: 'wedding photo - IMG_0649.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0650.JPG',
      alt: 'wedding photo - IMG_0650.JPG',
      caption: 'wedding photo - IMG_0650.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0651.JPG',
      alt: 'wedding photo - IMG_0651.JPG',
      caption: 'wedding photo - IMG_0651.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0652.JPG',
      alt: 'wedding photo - IMG_0652.JPG',
      caption: 'wedding photo - IMG_0652.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0653.JPG',
      alt: 'wedding photo - IMG_0653.JPG',
      caption: 'wedding photo - IMG_0653.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0654.JPG',
      alt: 'wedding photo - IMG_0654.JPG',
      caption: 'wedding photo - IMG_0654.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0655.JPG',
      alt: 'wedding photo - IMG_0655.JPG',
      caption: 'wedding photo - IMG_0655.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0656.JPG',
      alt: 'wedding photo - IMG_0656.JPG',
      caption: 'wedding photo - IMG_0656.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0657.JPG',
      alt: 'wedding photo - IMG_0657.JPG',
      caption: 'wedding photo - IMG_0657.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0658.JPG',
      alt: 'wedding photo - IMG_0658.JPG',
      caption: 'wedding photo - IMG_0658.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0660.JPG',
      alt: 'wedding photo - IMG_0660.JPG',
      caption: 'wedding photo - IMG_0660.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0661.JPG',
      alt: 'wedding photo - IMG_0661.JPG',
      caption: 'wedding photo - IMG_0661.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0662.JPG',
      alt: 'wedding photo - IMG_0662.JPG',
      caption: 'wedding photo - IMG_0662.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0663.JPG',
      alt: 'wedding photo - IMG_0663.JPG',
      caption: 'wedding photo - IMG_0663.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0664.JPG',
      alt: 'wedding photo - IMG_0664.JPG',
      caption: 'wedding photo - IMG_0664.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0665.JPG',
      alt: 'wedding photo - IMG_0665.JPG',
      caption: 'wedding photo - IMG_0665.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0666.JPG',
      alt: 'wedding photo - IMG_0666.JPG',
      caption: 'wedding photo - IMG_0666.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0667.JPG',
      alt: 'wedding photo - IMG_0667.JPG',
      caption: 'wedding photo - IMG_0667.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0668.JPG',
      alt: 'wedding photo - IMG_0668.JPG',
      caption: 'wedding photo - IMG_0668.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0669.JPG',
      alt: 'wedding photo - IMG_0669.JPG',
      caption: 'wedding photo - IMG_0669.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0670.JPG',
      alt: 'wedding photo - IMG_0670.JPG',
      caption: 'wedding photo - IMG_0670.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0671.JPG',
      alt: 'wedding photo - IMG_0671.JPG',
      caption: 'wedding photo - IMG_0671.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0672.JPG',
      alt: 'wedding photo - IMG_0672.JPG',
      caption: 'wedding photo - IMG_0672.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0673.JPG',
      alt: 'wedding photo - IMG_0673.JPG',
      caption: 'wedding photo - IMG_0673.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0674.JPG',
      alt: 'wedding photo - IMG_0674.JPG',
      caption: 'wedding photo - IMG_0674.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0675.JPG',
      alt: 'wedding photo - IMG_0675.JPG',
      caption: 'wedding photo - IMG_0675.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0676.JPG',
      alt: 'wedding photo - IMG_0676.JPG',
      caption: 'wedding photo - IMG_0676.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0677.JPG',
      alt: 'wedding photo - IMG_0677.JPG',
      caption: 'wedding photo - IMG_0677.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0678.JPG',
      alt: 'wedding photo - IMG_0678.JPG',
      caption: 'wedding photo - IMG_0678.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0679.JPG',
      alt: 'wedding photo - IMG_0679.JPG',
      caption: 'wedding photo - IMG_0679.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0680.JPG',
      alt: 'wedding photo - IMG_0680.JPG',
      caption: 'wedding photo - IMG_0680.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0681.JPG',
      alt: 'wedding photo - IMG_0681.JPG',
      caption: 'wedding photo - IMG_0681.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0682.JPG',
      alt: 'wedding photo - IMG_0682.JPG',
      caption: 'wedding photo - IMG_0682.JPG'
    },
    {
      src: '/images/galleries/wedding/JoannTesta_PeterPicone.jpg',
      alt: 'Joann Testa & Peter Picone',
      caption: 'Joann Testa & Peter Picone'
    },
    {
      src: '/images/galleries/wedding/GiuseppinaRossetti_PasqualeDeMarco.jpg',
      alt: 'Giuseppina Rossetti & Pasquale DeMarco',
      caption: 'Newlyweds - 1969'
    },
    {
      src: '/images/galleries/wedding/IMG_0640.JPG',
      alt: 'wedding photo - IMG_0640.JPG',
      caption: 'wedding photo - IMG_0640.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0641.JPG',
      alt: 'Wedding celebration photo',
      caption: 'Wedding celebration'
    },
    {
      src: '/images/galleries/wedding/IMG_0642.JPG',
      alt: 'wedding photo - IMG_0642.JPG',
      caption: 'wedding photo - IMG_0642.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0643.JPG',
      alt: 'wedding photo - IMG_0643.JPG',
      caption: 'wedding photo - IMG_0643.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0644.JPG',
      alt: 'wedding photo - IMG_0644.JPG',
      caption: 'wedding photo - IMG_0644.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0645.JPG',
      alt: 'wedding photo - IMG_0645.JPG',
      caption: 'wedding photo - IMG_0645.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0646.JPG',
      alt: 'wedding photo - IMG_0646.JPG',
      caption: 'wedding photo - IMG_0646.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0647.JPG',
      alt: 'wedding photo - IMG_0647.JPG',
      caption: 'wedding photo - IMG_0647.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0648.JPG',
      alt: 'wedding photo - IMG_0648.JPG',
      caption: 'wedding photo - IMG_0648.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0649.JPG',
      alt: 'wedding photo - IMG_0649.JPG',
      caption: 'wedding photo - IMG_0649.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0650.JPG',
      alt: 'wedding photo - IMG_0650.JPG',
      caption: 'wedding photo - IMG_0650.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0651.JPG',
      alt: 'wedding photo - IMG_0651.JPG',
      caption: 'wedding photo - IMG_0651.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0652.JPG',
      alt: 'wedding photo - IMG_0652.JPG',
      caption: 'wedding photo - IMG_0652.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0653.JPG',
      alt: 'wedding photo - IMG_0653.JPG',
      caption: 'wedding photo - IMG_0653.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0654.JPG',
      alt: 'wedding photo - IMG_0654.JPG',
      caption: 'wedding photo - IMG_0654.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0655.JPG',
      alt: 'wedding photo - IMG_0655.JPG',
      caption: 'wedding photo - IMG_0655.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0656.JPG',
      alt: 'wedding photo - IMG_0656.JPG',
      caption: 'wedding photo - IMG_0656.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0657.JPG',
      alt: 'wedding photo - IMG_0657.JPG',
      caption: 'wedding photo - IMG_0657.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0658.JPG',
      alt: 'wedding photo - IMG_0658.JPG',
      caption: 'wedding photo - IMG_0658.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0660.JPG',
      alt: 'wedding photo - IMG_0660.JPG',
      caption: 'wedding photo - IMG_0660.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0661.JPG',
      alt: 'wedding photo - IMG_0661.JPG',
      caption: 'wedding photo - IMG_0661.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0662.JPG',
      alt: 'wedding photo - IMG_0662.JPG',
      caption: 'wedding photo - IMG_0662.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0663.JPG',
      alt: 'wedding photo - IMG_0663.JPG',
      caption: 'wedding photo - IMG_0663.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0664.JPG',
      alt: 'wedding photo - IMG_0664.JPG',
      caption: 'wedding photo - IMG_0664.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0665.JPG',
      alt: 'wedding photo - IMG_0665.JPG',
      caption: 'wedding photo - IMG_0665.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0666.JPG',
      alt: 'wedding photo - IMG_0666.JPG',
      caption: 'wedding photo - IMG_0666.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0667.JPG',
      alt: 'wedding photo - IMG_0667.JPG',
      caption: 'wedding photo - IMG_0667.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0668.JPG',
      alt: 'wedding photo - IMG_0668.JPG',
      caption: 'wedding photo - IMG_0668.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0669.JPG',
      alt: 'wedding photo - IMG_0669.JPG',
      caption: 'wedding photo - IMG_0669.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0670.JPG',
      alt: 'wedding photo - IMG_0670.JPG',
      caption: 'wedding photo - IMG_0670.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0671.JPG',
      alt: 'wedding photo - IMG_0671.JPG',
      caption: 'wedding photo - IMG_0671.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0672.JPG',
      alt: 'wedding photo - IMG_0672.JPG',
      caption: 'wedding photo - IMG_0672.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0673.JPG',
      alt: 'wedding photo - IMG_0673.JPG',
      caption: 'wedding photo - IMG_0673.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0674.JPG',
      alt: 'wedding photo - IMG_0674.JPG',
      caption: 'wedding photo - IMG_0674.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0675.JPG',
      alt: 'wedding photo - IMG_0675.JPG',
      caption: 'wedding photo - IMG_0675.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0676.JPG',
      alt: 'wedding photo - IMG_0676.JPG',
      caption: 'wedding photo - IMG_0676.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0677.JPG',
      alt: 'wedding photo - IMG_0677.JPG',
      caption: 'wedding photo - IMG_0677.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0678.JPG',
      alt: 'wedding photo - IMG_0678.JPG',
      caption: 'wedding photo - IMG_0678.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0679.JPG',
      alt: 'wedding photo - IMG_0679.JPG',
      caption: 'wedding photo - IMG_0679.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0680.JPG',
      alt: 'wedding photo - IMG_0680.JPG',
      caption: 'wedding photo - IMG_0680.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0681.JPG',
      alt: 'wedding photo - IMG_0681.JPG',
      caption: 'wedding photo - IMG_0681.JPG'
    },
    {
      src: '/images/galleries/wedding/IMG_0682.JPG',
      alt: 'wedding photo - IMG_0682.JPG',
      caption: 'wedding photo - IMG_0682.JPG'
    },
    {
      src: '/images/galleries/wedding/JoannTesta_PeterPicone.jpg',
      alt: 'Joann Testa & Peter Picone',
      caption: 'Joann Testa & Peter Picone'
    }
  ],

  tomatoes: [
    {
      src: '/images/galleries/tomatoes/IMG_5021.JPEG',
      alt: 'tomatoes photo - IMG_5021.JPEG',
      caption: 'tomatoes photo - IMG_5021.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5030.JPEG',
      alt: 'tomatoes photo - IMG_5030.JPEG',
      caption: 'tomatoes photo - IMG_5030.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5035.JPEG',
      alt: 'tomatoes photo - IMG_5035.JPEG',
      caption: 'tomatoes photo - IMG_5035.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5041.JPEG',
      alt: 'tomatoes photo - IMG_5041.JPEG',
      caption: 'tomatoes photo - IMG_5041.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5064.JPEG',
      alt: 'tomatoes photo - IMG_5064.JPEG',
      caption: 'tomatoes photo - IMG_5064.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5071.JPEG',
      alt: 'tomatoes photo - IMG_5071.JPEG',
      caption: 'tomatoes photo - IMG_5071.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5085.JPEG',
      alt: 'tomatoes photo - IMG_5085.JPEG',
      caption: 'tomatoes photo - IMG_5085.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5090.JPEG',
      alt: 'tomatoes photo - IMG_5090.JPEG',
      caption: 'tomatoes photo - IMG_5090.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5103.JPG',
      alt: 'tomatoes photo - IMG_5103.JPG',
      caption: 'tomatoes photo - IMG_5103.JPG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5989.JPEG',
      alt: 'tomatoes photo - IMG_5989.JPEG',
      caption: 'tomatoes photo - IMG_5989.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5991.JPEG',
      alt: 'tomatoes photo - IMG_5991.JPEG',
      caption: 'tomatoes photo - IMG_5991.JPEG'
    },
    {
      src: '/images/galleries/tomatoes/IMG_5992.JPEG',
      alt: 'tomatoes photo - IMG_5992.JPEG',
      caption: 'tomatoes photo - IMG_5992.JPEG'
    }
  ],
  
  hello: [
    {
      src: '/images/galleries/hello/marco.demarco.jpg',
      alt: 'hello photo - marco.demarco.jpg',
      caption: 'hello photo - marco.demarco.jpg'
    },
    {
      src: '/images/galleries/hello/marco.demarco.jpg',
      alt: 'hello photo - marco.demarco.jpg',
      caption: 'hello photo - marco.demarco.jpg'
    }
  ],
  
  jeep: [
    {
      src: '/images/galleries/jeep/1-MyJeep-TheBoys.jpg',
      alt: 'jeep photo - 1-MyJeep-TheBoys.jpg',
      caption: 'jeep photo - 1-MyJeep-TheBoys.jpg'
    },
    {
      src: '/images/galleries/jeep/1-MyJeep-TheBoys2.jpg',
      alt: 'jeep photo - 1-MyJeep-TheBoys2.jpg',
      caption: 'jeep photo - 1-MyJeep-TheBoys2.jpg'
    },
    {
      src: '/images/galleries/jeep/10-MyJeep-FrontPassengerSide.jpg',
      alt: 'jeep photo - 10-MyJeep-FrontPassengerSide.jpg',
      caption: 'jeep photo - 10-MyJeep-FrontPassengerSide.jpg'
    },
    {
      src: '/images/galleries/jeep/11-MyJeep-RearPassengerSide.jpg',
      alt: 'jeep photo - 11-MyJeep-RearPassengerSide.jpg',
      caption: 'jeep photo - 11-MyJeep-RearPassengerSide.jpg'
    },
    {
      src: '/images/galleries/jeep/12-MyJeep-NewTiresRims.jpg',
      alt: 'jeep photo - 12-MyJeep-NewTiresRims.jpg',
      caption: 'jeep photo - 12-MyJeep-NewTiresRims.jpg'
    },
    {
      src: '/images/galleries/jeep/13-MyJeep-PassengerSide.jpg',
      alt: 'jeep photo - 13-MyJeep-PassengerSide.jpg',
      caption: 'jeep photo - 13-MyJeep-PassengerSide.jpg'
    },
    {
      src: '/images/galleries/jeep/14-MyJeep-PassengerSideWithHardTop.jpg',
      alt: 'jeep photo - 14-MyJeep-PassengerSideWithHardTop.jpg',
      caption: 'jeep photo - 14-MyJeep-PassengerSideWithHardTop.jpg'
    },
    {
      src: '/images/galleries/jeep/2-MyJeep-My2Boys.jpg',
      alt: 'jeep photo - 2-MyJeep-My2Boys.jpg',
      caption: 'jeep photo - 2-MyJeep-My2Boys.jpg'
    },
    {
      src: '/images/galleries/jeep/3-MyJeep-My2Boys-CmonAlready.jpg',
      alt: 'jeep photo - 3-MyJeep-My2Boys-CmonAlready.jpg',
      caption: 'jeep photo - 3-MyJeep-My2Boys-CmonAlready.jpg'
    },
    {
      src: '/images/galleries/jeep/4-MyJeep-My2Boys-WhereShouldWeGo.jpg',
      alt: 'jeep photo - 4-MyJeep-My2Boys-WhereShouldWeGo.jpg',
      caption: 'jeep photo - 4-MyJeep-My2Boys-WhereShouldWeGo.jpg'
    },
    {
      src: '/images/galleries/jeep/5-MyJeep-NapTime.jpg',
      alt: 'jeep photo - 5-MyJeep-NapTime.jpg',
      caption: 'jeep photo - 5-MyJeep-NapTime.jpg'
    },
    {
      src: '/images/galleries/jeep/6-MyJeeps.jpg',
      alt: 'jeep photo - 6-MyJeeps.jpg',
      caption: 'jeep photo - 6-MyJeeps.jpg'
    },
    {
      src: '/images/galleries/jeep/8-MyJeep-DriverSide.jpg',
      alt: 'jeep photo - 8-MyJeep-DriverSide.jpg',
      caption: 'jeep photo - 8-MyJeep-DriverSide.jpg'
    },
    {
      src: '/images/galleries/jeep/9-MyJeep-DriverSide2.jpg',
      alt: 'jeep photo - 9-MyJeep-DriverSide2.jpg',
      caption: 'jeep photo - 9-MyJeep-DriverSide2.jpg'
    }
  ],
  
  marco_luz: [
    {
      src: '/images/galleries/marco_luz/luz_marco-0001.jpg',
      alt: 'marco_luz photo - luz_marco-0001.jpg',
      caption: 'marco_luz photo - luz_marco-0001.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0002.jpg',
      alt: 'marco_luz photo - luz_marco-0002.jpg',
      caption: 'marco_luz photo - luz_marco-0002.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0003.jpg',
      alt: 'marco_luz photo - luz_marco-0003.jpg',
      caption: 'marco_luz photo - luz_marco-0003.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0004.jpg',
      alt: 'marco_luz photo - luz_marco-0004.jpg',
      caption: 'marco_luz photo - luz_marco-0004.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0005.jpg',
      alt: 'marco_luz photo - luz_marco-0005.jpg',
      caption: 'marco_luz photo - luz_marco-0005.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0006.jpg',
      alt: 'marco_luz photo - luz_marco-0006.jpg',
      caption: 'marco_luz photo - luz_marco-0006.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0007.jpg',
      alt: 'marco_luz photo - luz_marco-0007.jpg',
      caption: 'marco_luz photo - luz_marco-0007.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0008.jpg',
      alt: 'marco_luz photo - luz_marco-0008.jpg',
      caption: 'marco_luz photo - luz_marco-0008.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0009.jpg',
      alt: 'marco_luz photo - luz_marco-0009.jpg',
      caption: 'marco_luz photo - luz_marco-0009.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0010.jpg',
      alt: 'marco_luz photo - luz_marco-0010.jpg',
      caption: 'marco_luz photo - luz_marco-0010.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0011.jpg',
      alt: 'marco_luz photo - luz_marco-0011.jpg',
      caption: 'marco_luz photo - luz_marco-0011.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0012.jpg',
      alt: 'marco_luz photo - luz_marco-0012.jpg',
      caption: 'marco_luz photo - luz_marco-0012.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0013.jpg',
      alt: 'marco_luz photo - luz_marco-0013.jpg',
      caption: 'marco_luz photo - luz_marco-0013.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0014.jpg',
      alt: 'marco_luz photo - luz_marco-0014.jpg',
      caption: 'marco_luz photo - luz_marco-0014.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0015.jpg',
      alt: 'marco_luz photo - luz_marco-0015.jpg',
      caption: 'marco_luz photo - luz_marco-0015.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0016.jpg',
      alt: 'marco_luz photo - luz_marco-0016.jpg',
      caption: 'marco_luz photo - luz_marco-0016.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0017.jpg',
      alt: 'marco_luz photo - luz_marco-0017.jpg',
      caption: 'marco_luz photo - luz_marco-0017.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0018.jpg',
      alt: 'marco_luz photo - luz_marco-0018.jpg',
      caption: 'marco_luz photo - luz_marco-0018.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0019.jpg',
      alt: 'marco_luz photo - luz_marco-0019.jpg',
      caption: 'marco_luz photo - luz_marco-0019.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0020.jpg',
      alt: 'marco_luz photo - luz_marco-0020.jpg',
      caption: 'marco_luz photo - luz_marco-0020.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0021.jpg',
      alt: 'marco_luz photo - luz_marco-0021.jpg',
      caption: 'marco_luz photo - luz_marco-0021.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0022.jpg',
      alt: 'marco_luz photo - luz_marco-0022.jpg',
      caption: 'marco_luz photo - luz_marco-0022.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0023.jpg',
      alt: 'marco_luz photo - luz_marco-0023.jpg',
      caption: 'marco_luz photo - luz_marco-0023.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0024.jpg',
      alt: 'marco_luz photo - luz_marco-0024.jpg',
      caption: 'marco_luz photo - luz_marco-0024.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0025.jpg',
      alt: 'marco_luz photo - luz_marco-0025.jpg',
      caption: 'marco_luz photo - luz_marco-0025.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0026.jpg',
      alt: 'marco_luz photo - luz_marco-0026.jpg',
      caption: 'marco_luz photo - luz_marco-0026.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0027.jpg',
      alt: 'marco_luz photo - luz_marco-0027.jpg',
      caption: 'marco_luz photo - luz_marco-0027.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0028.jpg',
      alt: 'marco_luz photo - luz_marco-0028.jpg',
      caption: 'marco_luz photo - luz_marco-0028.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0029.jpg',
      alt: 'marco_luz photo - luz_marco-0029.jpg',
      caption: 'marco_luz photo - luz_marco-0029.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0030.jpg',
      alt: 'marco_luz photo - luz_marco-0030.jpg',
      caption: 'marco_luz photo - luz_marco-0030.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0031.jpg',
      alt: 'marco_luz photo - luz_marco-0031.jpg',
      caption: 'marco_luz photo - luz_marco-0031.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0032.jpg',
      alt: 'marco_luz photo - luz_marco-0032.jpg',
      caption: 'marco_luz photo - luz_marco-0032.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0033.jpg',
      alt: 'marco_luz photo - luz_marco-0033.jpg',
      caption: 'marco_luz photo - luz_marco-0033.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0034.jpg',
      alt: 'marco_luz photo - luz_marco-0034.jpg',
      caption: 'marco_luz photo - luz_marco-0034.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0035.jpg',
      alt: 'marco_luz photo - luz_marco-0035.jpg',
      caption: 'marco_luz photo - luz_marco-0035.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0036.jpg',
      alt: 'marco_luz photo - luz_marco-0036.jpg',
      caption: 'marco_luz photo - luz_marco-0036.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0037.jpg',
      alt: 'marco_luz photo - luz_marco-0037.jpg',
      caption: 'marco_luz photo - luz_marco-0037.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0038.jpg',
      alt: 'marco_luz photo - luz_marco-0038.jpg',
      caption: 'marco_luz photo - luz_marco-0038.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0039.jpg',
      alt: 'marco_luz photo - luz_marco-0039.jpg',
      caption: 'marco_luz photo - luz_marco-0039.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0040.jpg',
      alt: 'marco_luz photo - luz_marco-0040.jpg',
      caption: 'marco_luz photo - luz_marco-0040.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0041.jpg',
      alt: 'marco_luz photo - luz_marco-0041.jpg',
      caption: 'marco_luz photo - luz_marco-0041.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0042.jpg',
      alt: 'marco_luz photo - luz_marco-0042.jpg',
      caption: 'marco_luz photo - luz_marco-0042.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0043.jpg',
      alt: 'marco_luz photo - luz_marco-0043.jpg',
      caption: 'marco_luz photo - luz_marco-0043.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0044.jpg',
      alt: 'marco_luz photo - luz_marco-0044.jpg',
      caption: 'marco_luz photo - luz_marco-0044.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0045.jpg',
      alt: 'marco_luz photo - luz_marco-0045.jpg',
      caption: 'marco_luz photo - luz_marco-0045.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0046.jpg',
      alt: 'marco_luz photo - luz_marco-0046.jpg',
      caption: 'marco_luz photo - luz_marco-0046.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0047.jpg',
      alt: 'marco_luz photo - luz_marco-0047.jpg',
      caption: 'marco_luz photo - luz_marco-0047.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0048.jpg',
      alt: 'marco_luz photo - luz_marco-0048.jpg',
      caption: 'marco_luz photo - luz_marco-0048.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0049.jpg',
      alt: 'marco_luz photo - luz_marco-0049.jpg',
      caption: 'marco_luz photo - luz_marco-0049.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0050.jpg',
      alt: 'marco_luz photo - luz_marco-0050.jpg',
      caption: 'marco_luz photo - luz_marco-0050.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0051.jpg',
      alt: 'marco_luz photo - luz_marco-0051.jpg',
      caption: 'marco_luz photo - luz_marco-0051.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0052.jpg',
      alt: 'marco_luz photo - luz_marco-0052.jpg',
      caption: 'marco_luz photo - luz_marco-0052.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0053.jpg',
      alt: 'marco_luz photo - luz_marco-0053.jpg',
      caption: 'marco_luz photo - luz_marco-0053.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0054.jpg',
      alt: 'marco_luz photo - luz_marco-0054.jpg',
      caption: 'marco_luz photo - luz_marco-0054.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0055.jpg',
      alt: 'marco_luz photo - luz_marco-0055.jpg',
      caption: 'marco_luz photo - luz_marco-0055.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0056.jpg',
      alt: 'marco_luz photo - luz_marco-0056.jpg',
      caption: 'marco_luz photo - luz_marco-0056.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0057.jpg',
      alt: 'marco_luz photo - luz_marco-0057.jpg',
      caption: 'marco_luz photo - luz_marco-0057.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0058.jpg',
      alt: 'marco_luz photo - luz_marco-0058.jpg',
      caption: 'marco_luz photo - luz_marco-0058.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0059.jpg',
      alt: 'marco_luz photo - luz_marco-0059.jpg',
      caption: 'marco_luz photo - luz_marco-0059.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0060.jpg',
      alt: 'marco_luz photo - luz_marco-0060.jpg',
      caption: 'marco_luz photo - luz_marco-0060.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0061.jpg',
      alt: 'marco_luz photo - luz_marco-0061.jpg',
      caption: 'marco_luz photo - luz_marco-0061.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0062.jpg',
      alt: 'marco_luz photo - luz_marco-0062.jpg',
      caption: 'marco_luz photo - luz_marco-0062.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0063.jpg',
      alt: 'marco_luz photo - luz_marco-0063.jpg',
      caption: 'marco_luz photo - luz_marco-0063.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0064.jpg',
      alt: 'marco_luz photo - luz_marco-0064.jpg',
      caption: 'marco_luz photo - luz_marco-0064.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0065.jpg',
      alt: 'marco_luz photo - luz_marco-0065.jpg',
      caption: 'marco_luz photo - luz_marco-0065.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0066.jpg',
      alt: 'marco_luz photo - luz_marco-0066.jpg',
      caption: 'marco_luz photo - luz_marco-0066.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0067.jpg',
      alt: 'marco_luz photo - luz_marco-0067.jpg',
      caption: 'marco_luz photo - luz_marco-0067.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0068.jpg',
      alt: 'marco_luz photo - luz_marco-0068.jpg',
      caption: 'marco_luz photo - luz_marco-0068.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0069.jpg',
      alt: 'marco_luz photo - luz_marco-0069.jpg',
      caption: 'marco_luz photo - luz_marco-0069.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0070.jpg',
      alt: 'marco_luz photo - luz_marco-0070.jpg',
      caption: 'marco_luz photo - luz_marco-0070.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0071.jpg',
      alt: 'marco_luz photo - luz_marco-0071.jpg',
      caption: 'marco_luz photo - luz_marco-0071.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0072.jpg',
      alt: 'marco_luz photo - luz_marco-0072.jpg',
      caption: 'marco_luz photo - luz_marco-0072.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0073.jpg',
      alt: 'marco_luz photo - luz_marco-0073.jpg',
      caption: 'marco_luz photo - luz_marco-0073.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0074.jpg',
      alt: 'marco_luz photo - luz_marco-0074.jpg',
      caption: 'marco_luz photo - luz_marco-0074.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0075.jpg',
      alt: 'marco_luz photo - luz_marco-0075.jpg',
      caption: 'marco_luz photo - luz_marco-0075.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0076.jpg',
      alt: 'marco_luz photo - luz_marco-0076.jpg',
      caption: 'marco_luz photo - luz_marco-0076.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0077.jpg',
      alt: 'marco_luz photo - luz_marco-0077.jpg',
      caption: 'marco_luz photo - luz_marco-0077.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0078.jpg',
      alt: 'marco_luz photo - luz_marco-0078.jpg',
      caption: 'marco_luz photo - luz_marco-0078.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0079.jpg',
      alt: 'marco_luz photo - luz_marco-0079.jpg',
      caption: 'marco_luz photo - luz_marco-0079.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0080.jpg',
      alt: 'marco_luz photo - luz_marco-0080.jpg',
      caption: 'marco_luz photo - luz_marco-0080.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0081.jpg',
      alt: 'marco_luz photo - luz_marco-0081.jpg',
      caption: 'marco_luz photo - luz_marco-0081.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0082.jpg',
      alt: 'marco_luz photo - luz_marco-0082.jpg',
      caption: 'marco_luz photo - luz_marco-0082.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0083.jpg',
      alt: 'marco_luz photo - luz_marco-0083.jpg',
      caption: 'marco_luz photo - luz_marco-0083.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0084.jpg',
      alt: 'marco_luz photo - luz_marco-0084.jpg',
      caption: 'marco_luz photo - luz_marco-0084.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0085.jpg',
      alt: 'marco_luz photo - luz_marco-0085.jpg',
      caption: 'marco_luz photo - luz_marco-0085.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0086.jpg',
      alt: 'marco_luz photo - luz_marco-0086.jpg',
      caption: 'marco_luz photo - luz_marco-0086.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0087.jpg',
      alt: 'marco_luz photo - luz_marco-0087.jpg',
      caption: 'marco_luz photo - luz_marco-0087.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0088.jpg',
      alt: 'marco_luz photo - luz_marco-0088.jpg',
      caption: 'marco_luz photo - luz_marco-0088.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0089.jpg',
      alt: 'marco_luz photo - luz_marco-0089.jpg',
      caption: 'marco_luz photo - luz_marco-0089.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0090.jpg',
      alt: 'marco_luz photo - luz_marco-0090.jpg',
      caption: 'marco_luz photo - luz_marco-0090.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0091.jpg',
      alt: 'marco_luz photo - luz_marco-0091.jpg',
      caption: 'marco_luz photo - luz_marco-0091.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0092.jpg',
      alt: 'marco_luz photo - luz_marco-0092.jpg',
      caption: 'marco_luz photo - luz_marco-0092.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0093.jpg',
      alt: 'marco_luz photo - luz_marco-0093.jpg',
      caption: 'marco_luz photo - luz_marco-0093.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0094.jpg',
      alt: 'marco_luz photo - luz_marco-0094.jpg',
      caption: 'marco_luz photo - luz_marco-0094.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0095.jpg',
      alt: 'marco_luz photo - luz_marco-0095.jpg',
      caption: 'marco_luz photo - luz_marco-0095.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0096.jpg',
      alt: 'marco_luz photo - luz_marco-0096.jpg',
      caption: 'marco_luz photo - luz_marco-0096.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0097.jpg',
      alt: 'marco_luz photo - luz_marco-0097.jpg',
      caption: 'marco_luz photo - luz_marco-0097.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0098.jpg',
      alt: 'marco_luz photo - luz_marco-0098.jpg',
      caption: 'marco_luz photo - luz_marco-0098.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0099.jpg',
      alt: 'marco_luz photo - luz_marco-0099.jpg',
      caption: 'marco_luz photo - luz_marco-0099.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0100.jpg',
      alt: 'marco_luz photo - luz_marco-0100.jpg',
      caption: 'marco_luz photo - luz_marco-0100.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0101.jpg',
      alt: 'marco_luz photo - luz_marco-0101.jpg',
      caption: 'marco_luz photo - luz_marco-0101.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0102.jpg',
      alt: 'marco_luz photo - luz_marco-0102.jpg',
      caption: 'marco_luz photo - luz_marco-0102.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0103.jpg',
      alt: 'marco_luz photo - luz_marco-0103.jpg',
      caption: 'marco_luz photo - luz_marco-0103.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0104.jpg',
      alt: 'marco_luz photo - luz_marco-0104.jpg',
      caption: 'marco_luz photo - luz_marco-0104.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0105.jpg',
      alt: 'marco_luz photo - luz_marco-0105.jpg',
      caption: 'marco_luz photo - luz_marco-0105.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0106.jpg',
      alt: 'marco_luz photo - luz_marco-0106.jpg',
      caption: 'marco_luz photo - luz_marco-0106.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0107.jpg',
      alt: 'marco_luz photo - luz_marco-0107.jpg',
      caption: 'marco_luz photo - luz_marco-0107.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0108.jpg',
      alt: 'marco_luz photo - luz_marco-0108.jpg',
      caption: 'marco_luz photo - luz_marco-0108.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0109.jpg',
      alt: 'marco_luz photo - luz_marco-0109.jpg',
      caption: 'marco_luz photo - luz_marco-0109.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0110.jpg',
      alt: 'marco_luz photo - luz_marco-0110.jpg',
      caption: 'marco_luz photo - luz_marco-0110.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0111.jpg',
      alt: 'marco_luz photo - luz_marco-0111.jpg',
      caption: 'marco_luz photo - luz_marco-0111.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0112.jpg',
      alt: 'marco_luz photo - luz_marco-0112.jpg',
      caption: 'marco_luz photo - luz_marco-0112.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0113.jpg',
      alt: 'marco_luz photo - luz_marco-0113.jpg',
      caption: 'marco_luz photo - luz_marco-0113.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0114.jpg',
      alt: 'marco_luz photo - luz_marco-0114.jpg',
      caption: 'marco_luz photo - luz_marco-0114.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0115.jpg',
      alt: 'marco_luz photo - luz_marco-0115.jpg',
      caption: 'marco_luz photo - luz_marco-0115.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0116.jpg',
      alt: 'marco_luz photo - luz_marco-0116.jpg',
      caption: 'marco_luz photo - luz_marco-0116.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0117.jpg',
      alt: 'marco_luz photo - luz_marco-0117.jpg',
      caption: 'marco_luz photo - luz_marco-0117.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0118.jpg',
      alt: 'marco_luz photo - luz_marco-0118.jpg',
      caption: 'marco_luz photo - luz_marco-0118.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0119.jpg',
      alt: 'marco_luz photo - luz_marco-0119.jpg',
      caption: 'marco_luz photo - luz_marco-0119.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0120.jpg',
      alt: 'marco_luz photo - luz_marco-0120.jpg',
      caption: 'marco_luz photo - luz_marco-0120.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0121.jpg',
      alt: 'marco_luz photo - luz_marco-0121.jpg',
      caption: 'marco_luz photo - luz_marco-0121.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0122.jpg',
      alt: 'marco_luz photo - luz_marco-0122.jpg',
      caption: 'marco_luz photo - luz_marco-0122.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0123.jpg',
      alt: 'marco_luz photo - luz_marco-0123.jpg',
      caption: 'marco_luz photo - luz_marco-0123.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0124.jpg',
      alt: 'marco_luz photo - luz_marco-0124.jpg',
      caption: 'marco_luz photo - luz_marco-0124.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0125.jpg',
      alt: 'marco_luz photo - luz_marco-0125.jpg',
      caption: 'marco_luz photo - luz_marco-0125.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0126.jpg',
      alt: 'marco_luz photo - luz_marco-0126.jpg',
      caption: 'marco_luz photo - luz_marco-0126.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0127.jpg',
      alt: 'marco_luz photo - luz_marco-0127.jpg',
      caption: 'marco_luz photo - luz_marco-0127.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0128.jpg',
      alt: 'marco_luz photo - luz_marco-0128.jpg',
      caption: 'marco_luz photo - luz_marco-0128.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0129.jpg',
      alt: 'marco_luz photo - luz_marco-0129.jpg',
      caption: 'marco_luz photo - luz_marco-0129.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0130.jpg',
      alt: 'marco_luz photo - luz_marco-0130.jpg',
      caption: 'marco_luz photo - luz_marco-0130.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0131.jpg',
      alt: 'marco_luz photo - luz_marco-0131.jpg',
      caption: 'marco_luz photo - luz_marco-0131.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0132.jpg',
      alt: 'marco_luz photo - luz_marco-0132.jpg',
      caption: 'marco_luz photo - luz_marco-0132.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0133.jpg',
      alt: 'marco_luz photo - luz_marco-0133.jpg',
      caption: 'marco_luz photo - luz_marco-0133.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0134.jpg',
      alt: 'marco_luz photo - luz_marco-0134.jpg',
      caption: 'marco_luz photo - luz_marco-0134.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0135.jpg',
      alt: 'marco_luz photo - luz_marco-0135.jpg',
      caption: 'marco_luz photo - luz_marco-0135.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0136.jpg',
      alt: 'marco_luz photo - luz_marco-0136.jpg',
      caption: 'marco_luz photo - luz_marco-0136.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0137.jpg',
      alt: 'marco_luz photo - luz_marco-0137.jpg',
      caption: 'marco_luz photo - luz_marco-0137.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0138.jpg',
      alt: 'marco_luz photo - luz_marco-0138.jpg',
      caption: 'marco_luz photo - luz_marco-0138.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0139.jpg',
      alt: 'marco_luz photo - luz_marco-0139.jpg',
      caption: 'marco_luz photo - luz_marco-0139.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0140.jpg',
      alt: 'marco_luz photo - luz_marco-0140.jpg',
      caption: 'marco_luz photo - luz_marco-0140.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0141.jpg',
      alt: 'marco_luz photo - luz_marco-0141.jpg',
      caption: 'marco_luz photo - luz_marco-0141.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0142.jpg',
      alt: 'marco_luz photo - luz_marco-0142.jpg',
      caption: 'marco_luz photo - luz_marco-0142.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0143.jpg',
      alt: 'marco_luz photo - luz_marco-0143.jpg',
      caption: 'marco_luz photo - luz_marco-0143.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0144.jpg',
      alt: 'marco_luz photo - luz_marco-0144.jpg',
      caption: 'marco_luz photo - luz_marco-0144.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0145.jpg',
      alt: 'marco_luz photo - luz_marco-0145.jpg',
      caption: 'marco_luz photo - luz_marco-0145.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0146.jpg',
      alt: 'marco_luz photo - luz_marco-0146.jpg',
      caption: 'marco_luz photo - luz_marco-0146.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0147.jpg',
      alt: 'marco_luz photo - luz_marco-0147.jpg',
      caption: 'marco_luz photo - luz_marco-0147.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0148.jpg',
      alt: 'marco_luz photo - luz_marco-0148.jpg',
      caption: 'marco_luz photo - luz_marco-0148.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0149.jpg',
      alt: 'marco_luz photo - luz_marco-0149.jpg',
      caption: 'marco_luz photo - luz_marco-0149.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0150.jpg',
      alt: 'marco_luz photo - luz_marco-0150.jpg',
      caption: 'marco_luz photo - luz_marco-0150.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0151.jpg',
      alt: 'marco_luz photo - luz_marco-0151.jpg',
      caption: 'marco_luz photo - luz_marco-0151.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0152.jpg',
      alt: 'marco_luz photo - luz_marco-0152.jpg',
      caption: 'marco_luz photo - luz_marco-0152.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0153.jpg',
      alt: 'marco_luz photo - luz_marco-0153.jpg',
      caption: 'marco_luz photo - luz_marco-0153.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0154.jpg',
      alt: 'marco_luz photo - luz_marco-0154.jpg',
      caption: 'marco_luz photo - luz_marco-0154.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0155.jpg',
      alt: 'marco_luz photo - luz_marco-0155.jpg',
      caption: 'marco_luz photo - luz_marco-0155.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0156.jpg',
      alt: 'marco_luz photo - luz_marco-0156.jpg',
      caption: 'marco_luz photo - luz_marco-0156.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0157.jpg',
      alt: 'marco_luz photo - luz_marco-0157.jpg',
      caption: 'marco_luz photo - luz_marco-0157.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0158.jpg',
      alt: 'marco_luz photo - luz_marco-0158.jpg',
      caption: 'marco_luz photo - luz_marco-0158.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0159.jpg',
      alt: 'marco_luz photo - luz_marco-0159.jpg',
      caption: 'marco_luz photo - luz_marco-0159.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0160.jpg',
      alt: 'marco_luz photo - luz_marco-0160.jpg',
      caption: 'marco_luz photo - luz_marco-0160.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0161.jpg',
      alt: 'marco_luz photo - luz_marco-0161.jpg',
      caption: 'marco_luz photo - luz_marco-0161.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0162.jpg',
      alt: 'marco_luz photo - luz_marco-0162.jpg',
      caption: 'marco_luz photo - luz_marco-0162.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0163.jpg',
      alt: 'marco_luz photo - luz_marco-0163.jpg',
      caption: 'marco_luz photo - luz_marco-0163.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0164.jpg',
      alt: 'marco_luz photo - luz_marco-0164.jpg',
      caption: 'marco_luz photo - luz_marco-0164.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0165.jpg',
      alt: 'marco_luz photo - luz_marco-0165.jpg',
      caption: 'marco_luz photo - luz_marco-0165.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0166.jpg',
      alt: 'marco_luz photo - luz_marco-0166.jpg',
      caption: 'marco_luz photo - luz_marco-0166.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0167.jpg',
      alt: 'marco_luz photo - luz_marco-0167.jpg',
      caption: 'marco_luz photo - luz_marco-0167.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0168.jpg',
      alt: 'marco_luz photo - luz_marco-0168.jpg',
      caption: 'marco_luz photo - luz_marco-0168.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0169.jpg',
      alt: 'marco_luz photo - luz_marco-0169.jpg',
      caption: 'marco_luz photo - luz_marco-0169.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0170.jpg',
      alt: 'marco_luz photo - luz_marco-0170.jpg',
      caption: 'marco_luz photo - luz_marco-0170.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0171.jpg',
      alt: 'marco_luz photo - luz_marco-0171.jpg',
      caption: 'marco_luz photo - luz_marco-0171.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0172.jpg',
      alt: 'marco_luz photo - luz_marco-0172.jpg',
      caption: 'marco_luz photo - luz_marco-0172.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0173.jpg',
      alt: 'marco_luz photo - luz_marco-0173.jpg',
      caption: 'marco_luz photo - luz_marco-0173.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0174.jpg',
      alt: 'marco_luz photo - luz_marco-0174.jpg',
      caption: 'marco_luz photo - luz_marco-0174.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0175.jpg',
      alt: 'marco_luz photo - luz_marco-0175.jpg',
      caption: 'marco_luz photo - luz_marco-0175.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0176.jpg',
      alt: 'marco_luz photo - luz_marco-0176.jpg',
      caption: 'marco_luz photo - luz_marco-0176.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0177.jpg',
      alt: 'marco_luz photo - luz_marco-0177.jpg',
      caption: 'marco_luz photo - luz_marco-0177.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0178.jpg',
      alt: 'marco_luz photo - luz_marco-0178.jpg',
      caption: 'marco_luz photo - luz_marco-0178.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0179.jpg',
      alt: 'marco_luz photo - luz_marco-0179.jpg',
      caption: 'marco_luz photo - luz_marco-0179.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0180.jpg',
      alt: 'marco_luz photo - luz_marco-0180.jpg',
      caption: 'marco_luz photo - luz_marco-0180.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0181.jpg',
      alt: 'marco_luz photo - luz_marco-0181.jpg',
      caption: 'marco_luz photo - luz_marco-0181.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0182.jpg',
      alt: 'marco_luz photo - luz_marco-0182.jpg',
      caption: 'marco_luz photo - luz_marco-0182.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0183.jpg',
      alt: 'marco_luz photo - luz_marco-0183.jpg',
      caption: 'marco_luz photo - luz_marco-0183.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0184.jpg',
      alt: 'marco_luz photo - luz_marco-0184.jpg',
      caption: 'marco_luz photo - luz_marco-0184.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0185.jpg',
      alt: 'marco_luz photo - luz_marco-0185.jpg',
      caption: 'marco_luz photo - luz_marco-0185.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0186.jpg',
      alt: 'marco_luz photo - luz_marco-0186.jpg',
      caption: 'marco_luz photo - luz_marco-0186.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0187.jpg',
      alt: 'marco_luz photo - luz_marco-0187.jpg',
      caption: 'marco_luz photo - luz_marco-0187.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0188.jpg',
      alt: 'marco_luz photo - luz_marco-0188.jpg',
      caption: 'marco_luz photo - luz_marco-0188.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0189.jpg',
      alt: 'marco_luz photo - luz_marco-0189.jpg',
      caption: 'marco_luz photo - luz_marco-0189.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0190.jpg',
      alt: 'marco_luz photo - luz_marco-0190.jpg',
      caption: 'marco_luz photo - luz_marco-0190.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0191.jpg',
      alt: 'marco_luz photo - luz_marco-0191.jpg',
      caption: 'marco_luz photo - luz_marco-0191.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0192.jpg',
      alt: 'marco_luz photo - luz_marco-0192.jpg',
      caption: 'marco_luz photo - luz_marco-0192.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0193.jpg',
      alt: 'marco_luz photo - luz_marco-0193.jpg',
      caption: 'marco_luz photo - luz_marco-0193.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0194.jpg',
      alt: 'marco_luz photo - luz_marco-0194.jpg',
      caption: 'marco_luz photo - luz_marco-0194.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0195.jpg',
      alt: 'marco_luz photo - luz_marco-0195.jpg',
      caption: 'marco_luz photo - luz_marco-0195.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0196.jpg',
      alt: 'marco_luz photo - luz_marco-0196.jpg',
      caption: 'marco_luz photo - luz_marco-0196.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0197.jpg',
      alt: 'marco_luz photo - luz_marco-0197.jpg',
      caption: 'marco_luz photo - luz_marco-0197.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0198.jpg',
      alt: 'marco_luz photo - luz_marco-0198.jpg',
      caption: 'marco_luz photo - luz_marco-0198.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0199.jpg',
      alt: 'marco_luz photo - luz_marco-0199.jpg',
      caption: 'marco_luz photo - luz_marco-0199.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0200.jpg',
      alt: 'marco_luz photo - luz_marco-0200.jpg',
      caption: 'marco_luz photo - luz_marco-0200.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0201.jpg',
      alt: 'marco_luz photo - luz_marco-0201.jpg',
      caption: 'marco_luz photo - luz_marco-0201.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0202.jpg',
      alt: 'marco_luz photo - luz_marco-0202.jpg',
      caption: 'marco_luz photo - luz_marco-0202.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0203.jpg',
      alt: 'marco_luz photo - luz_marco-0203.jpg',
      caption: 'marco_luz photo - luz_marco-0203.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0204.jpg',
      alt: 'marco_luz photo - luz_marco-0204.jpg',
      caption: 'marco_luz photo - luz_marco-0204.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0205.jpg',
      alt: 'marco_luz photo - luz_marco-0205.jpg',
      caption: 'marco_luz photo - luz_marco-0205.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0206.jpg',
      alt: 'marco_luz photo - luz_marco-0206.jpg',
      caption: 'marco_luz photo - luz_marco-0206.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0207.jpg',
      alt: 'marco_luz photo - luz_marco-0207.jpg',
      caption: 'marco_luz photo - luz_marco-0207.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0208.jpg',
      alt: 'marco_luz photo - luz_marco-0208.jpg',
      caption: 'marco_luz photo - luz_marco-0208.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0209.jpg',
      alt: 'marco_luz photo - luz_marco-0209.jpg',
      caption: 'marco_luz photo - luz_marco-0209.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0210.jpg',
      alt: 'marco_luz photo - luz_marco-0210.jpg',
      caption: 'marco_luz photo - luz_marco-0210.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0211.jpg',
      alt: 'marco_luz photo - luz_marco-0211.jpg',
      caption: 'marco_luz photo - luz_marco-0211.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0212.jpg',
      alt: 'marco_luz photo - luz_marco-0212.jpg',
      caption: 'marco_luz photo - luz_marco-0212.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0213.jpg',
      alt: 'marco_luz photo - luz_marco-0213.jpg',
      caption: 'marco_luz photo - luz_marco-0213.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0214.jpg',
      alt: 'marco_luz photo - luz_marco-0214.jpg',
      caption: 'marco_luz photo - luz_marco-0214.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0215.jpg',
      alt: 'marco_luz photo - luz_marco-0215.jpg',
      caption: 'marco_luz photo - luz_marco-0215.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0216.jpg',
      alt: 'marco_luz photo - luz_marco-0216.jpg',
      caption: 'marco_luz photo - luz_marco-0216.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0217.jpg',
      alt: 'marco_luz photo - luz_marco-0217.jpg',
      caption: 'marco_luz photo - luz_marco-0217.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0218.jpg',
      alt: 'marco_luz photo - luz_marco-0218.jpg',
      caption: 'marco_luz photo - luz_marco-0218.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0219.jpg',
      alt: 'marco_luz photo - luz_marco-0219.jpg',
      caption: 'marco_luz photo - luz_marco-0219.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0220.jpg',
      alt: 'marco_luz photo - luz_marco-0220.jpg',
      caption: 'marco_luz photo - luz_marco-0220.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0221.jpg',
      alt: 'marco_luz photo - luz_marco-0221.jpg',
      caption: 'marco_luz photo - luz_marco-0221.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0222.jpg',
      alt: 'marco_luz photo - luz_marco-0222.jpg',
      caption: 'marco_luz photo - luz_marco-0222.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0223.jpg',
      alt: 'marco_luz photo - luz_marco-0223.jpg',
      caption: 'marco_luz photo - luz_marco-0223.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0224.jpg',
      alt: 'marco_luz photo - luz_marco-0224.jpg',
      caption: 'marco_luz photo - luz_marco-0224.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0225.jpg',
      alt: 'marco_luz photo - luz_marco-0225.jpg',
      caption: 'marco_luz photo - luz_marco-0225.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0226.jpg',
      alt: 'marco_luz photo - luz_marco-0226.jpg',
      caption: 'marco_luz photo - luz_marco-0226.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0227.jpg',
      alt: 'marco_luz photo - luz_marco-0227.jpg',
      caption: 'marco_luz photo - luz_marco-0227.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0228.jpg',
      alt: 'marco_luz photo - luz_marco-0228.jpg',
      caption: 'marco_luz photo - luz_marco-0228.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0229.jpg',
      alt: 'marco_luz photo - luz_marco-0229.jpg',
      caption: 'marco_luz photo - luz_marco-0229.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0230.jpg',
      alt: 'marco_luz photo - luz_marco-0230.jpg',
      caption: 'marco_luz photo - luz_marco-0230.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0231.jpg',
      alt: 'marco_luz photo - luz_marco-0231.jpg',
      caption: 'marco_luz photo - luz_marco-0231.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0232.jpg',
      alt: 'marco_luz photo - luz_marco-0232.jpg',
      caption: 'marco_luz photo - luz_marco-0232.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0233.jpg',
      alt: 'marco_luz photo - luz_marco-0233.jpg',
      caption: 'marco_luz photo - luz_marco-0233.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0234.jpg',
      alt: 'marco_luz photo - luz_marco-0234.jpg',
      caption: 'marco_luz photo - luz_marco-0234.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0235.jpg',
      alt: 'marco_luz photo - luz_marco-0235.jpg',
      caption: 'marco_luz photo - luz_marco-0235.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0236.jpg',
      alt: 'marco_luz photo - luz_marco-0236.jpg',
      caption: 'marco_luz photo - luz_marco-0236.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0237.jpg',
      alt: 'marco_luz photo - luz_marco-0237.jpg',
      caption: 'marco_luz photo - luz_marco-0237.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0238.jpg',
      alt: 'marco_luz photo - luz_marco-0238.jpg',
      caption: 'marco_luz photo - luz_marco-0238.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0239.jpg',
      alt: 'marco_luz photo - luz_marco-0239.jpg',
      caption: 'marco_luz photo - luz_marco-0239.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0240.jpg',
      alt: 'marco_luz photo - luz_marco-0240.jpg',
      caption: 'marco_luz photo - luz_marco-0240.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0241.jpg',
      alt: 'marco_luz photo - luz_marco-0241.jpg',
      caption: 'marco_luz photo - luz_marco-0241.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0242.jpg',
      alt: 'marco_luz photo - luz_marco-0242.jpg',
      caption: 'marco_luz photo - luz_marco-0242.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0243.jpg',
      alt: 'marco_luz photo - luz_marco-0243.jpg',
      caption: 'marco_luz photo - luz_marco-0243.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0244.jpg',
      alt: 'marco_luz photo - luz_marco-0244.jpg',
      caption: 'marco_luz photo - luz_marco-0244.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0245.jpg',
      alt: 'marco_luz photo - luz_marco-0245.jpg',
      caption: 'marco_luz photo - luz_marco-0245.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0246.jpg',
      alt: 'marco_luz photo - luz_marco-0246.jpg',
      caption: 'marco_luz photo - luz_marco-0246.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0247.jpg',
      alt: 'marco_luz photo - luz_marco-0247.jpg',
      caption: 'marco_luz photo - luz_marco-0247.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0248.jpg',
      alt: 'marco_luz photo - luz_marco-0248.jpg',
      caption: 'marco_luz photo - luz_marco-0248.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0249.jpg',
      alt: 'marco_luz photo - luz_marco-0249.jpg',
      caption: 'marco_luz photo - luz_marco-0249.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0250.jpg',
      alt: 'marco_luz photo - luz_marco-0250.jpg',
      caption: 'marco_luz photo - luz_marco-0250.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0251.jpg',
      alt: 'marco_luz photo - luz_marco-0251.jpg',
      caption: 'marco_luz photo - luz_marco-0251.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0252.jpg',
      alt: 'marco_luz photo - luz_marco-0252.jpg',
      caption: 'marco_luz photo - luz_marco-0252.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0253.jpg',
      alt: 'marco_luz photo - luz_marco-0253.jpg',
      caption: 'marco_luz photo - luz_marco-0253.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0254.jpg',
      alt: 'marco_luz photo - luz_marco-0254.jpg',
      caption: 'marco_luz photo - luz_marco-0254.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0255.jpg',
      alt: 'marco_luz photo - luz_marco-0255.jpg',
      caption: 'marco_luz photo - luz_marco-0255.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0256.jpg',
      alt: 'marco_luz photo - luz_marco-0256.jpg',
      caption: 'marco_luz photo - luz_marco-0256.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0257.jpg',
      alt: 'marco_luz photo - luz_marco-0257.jpg',
      caption: 'marco_luz photo - luz_marco-0257.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0258.jpg',
      alt: 'marco_luz photo - luz_marco-0258.jpg',
      caption: 'marco_luz photo - luz_marco-0258.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0259.jpg',
      alt: 'marco_luz photo - luz_marco-0259.jpg',
      caption: 'marco_luz photo - luz_marco-0259.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0260.jpg',
      alt: 'marco_luz photo - luz_marco-0260.jpg',
      caption: 'marco_luz photo - luz_marco-0260.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0261.jpg',
      alt: 'marco_luz photo - luz_marco-0261.jpg',
      caption: 'marco_luz photo - luz_marco-0261.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0262.jpg',
      alt: 'marco_luz photo - luz_marco-0262.jpg',
      caption: 'marco_luz photo - luz_marco-0262.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0263.jpg',
      alt: 'marco_luz photo - luz_marco-0263.jpg',
      caption: 'marco_luz photo - luz_marco-0263.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0264.jpg',
      alt: 'marco_luz photo - luz_marco-0264.jpg',
      caption: 'marco_luz photo - luz_marco-0264.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0265.jpg',
      alt: 'marco_luz photo - luz_marco-0265.jpg',
      caption: 'marco_luz photo - luz_marco-0265.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0266.jpg',
      alt: 'marco_luz photo - luz_marco-0266.jpg',
      caption: 'marco_luz photo - luz_marco-0266.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0267.jpg',
      alt: 'marco_luz photo - luz_marco-0267.jpg',
      caption: 'marco_luz photo - luz_marco-0267.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0268.jpg',
      alt: 'marco_luz photo - luz_marco-0268.jpg',
      caption: 'marco_luz photo - luz_marco-0268.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0269.jpg',
      alt: 'marco_luz photo - luz_marco-0269.jpg',
      caption: 'marco_luz photo - luz_marco-0269.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0270.jpg',
      alt: 'marco_luz photo - luz_marco-0270.jpg',
      caption: 'marco_luz photo - luz_marco-0270.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0271.jpg',
      alt: 'marco_luz photo - luz_marco-0271.jpg',
      caption: 'marco_luz photo - luz_marco-0271.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0272.jpg',
      alt: 'marco_luz photo - luz_marco-0272.jpg',
      caption: 'marco_luz photo - luz_marco-0272.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0273.jpg',
      alt: 'marco_luz photo - luz_marco-0273.jpg',
      caption: 'marco_luz photo - luz_marco-0273.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0274.jpg',
      alt: 'marco_luz photo - luz_marco-0274.jpg',
      caption: 'marco_luz photo - luz_marco-0274.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0275.jpg',
      alt: 'marco_luz photo - luz_marco-0275.jpg',
      caption: 'marco_luz photo - luz_marco-0275.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0276.jpg',
      alt: 'marco_luz photo - luz_marco-0276.jpg',
      caption: 'marco_luz photo - luz_marco-0276.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0277.jpg',
      alt: 'marco_luz photo - luz_marco-0277.jpg',
      caption: 'marco_luz photo - luz_marco-0277.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0278.jpg',
      alt: 'marco_luz photo - luz_marco-0278.jpg',
      caption: 'marco_luz photo - luz_marco-0278.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0279.jpg',
      alt: 'marco_luz photo - luz_marco-0279.jpg',
      caption: 'marco_luz photo - luz_marco-0279.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0280.jpg',
      alt: 'marco_luz photo - luz_marco-0280.jpg',
      caption: 'marco_luz photo - luz_marco-0280.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0281.jpg',
      alt: 'marco_luz photo - luz_marco-0281.jpg',
      caption: 'marco_luz photo - luz_marco-0281.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0282.jpg',
      alt: 'marco_luz photo - luz_marco-0282.jpg',
      caption: 'marco_luz photo - luz_marco-0282.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0283.jpg',
      alt: 'marco_luz photo - luz_marco-0283.jpg',
      caption: 'marco_luz photo - luz_marco-0283.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0284.jpg',
      alt: 'marco_luz photo - luz_marco-0284.jpg',
      caption: 'marco_luz photo - luz_marco-0284.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0285.jpg',
      alt: 'marco_luz photo - luz_marco-0285.jpg',
      caption: 'marco_luz photo - luz_marco-0285.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0286.jpg',
      alt: 'marco_luz photo - luz_marco-0286.jpg',
      caption: 'marco_luz photo - luz_marco-0286.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0287.jpg',
      alt: 'marco_luz photo - luz_marco-0287.jpg',
      caption: 'marco_luz photo - luz_marco-0287.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0288.jpg',
      alt: 'marco_luz photo - luz_marco-0288.jpg',
      caption: 'marco_luz photo - luz_marco-0288.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0289.jpg',
      alt: 'marco_luz photo - luz_marco-0289.jpg',
      caption: 'marco_luz photo - luz_marco-0289.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0290.jpg',
      alt: 'marco_luz photo - luz_marco-0290.jpg',
      caption: 'marco_luz photo - luz_marco-0290.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0291.jpg',
      alt: 'marco_luz photo - luz_marco-0291.jpg',
      caption: 'marco_luz photo - luz_marco-0291.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0292.jpg',
      alt: 'marco_luz photo - luz_marco-0292.jpg',
      caption: 'marco_luz photo - luz_marco-0292.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0293.jpg',
      alt: 'marco_luz photo - luz_marco-0293.jpg',
      caption: 'marco_luz photo - luz_marco-0293.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0294.jpg',
      alt: 'marco_luz photo - luz_marco-0294.jpg',
      caption: 'marco_luz photo - luz_marco-0294.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0295.jpg',
      alt: 'marco_luz photo - luz_marco-0295.jpg',
      caption: 'marco_luz photo - luz_marco-0295.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0296.jpg',
      alt: 'marco_luz photo - luz_marco-0296.jpg',
      caption: 'marco_luz photo - luz_marco-0296.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0297.jpg',
      alt: 'marco_luz photo - luz_marco-0297.jpg',
      caption: 'marco_luz photo - luz_marco-0297.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0298.jpg',
      alt: 'marco_luz photo - luz_marco-0298.jpg',
      caption: 'marco_luz photo - luz_marco-0298.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0299.jpg',
      alt: 'marco_luz photo - luz_marco-0299.jpg',
      caption: 'marco_luz photo - luz_marco-0299.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0300.jpg',
      alt: 'marco_luz photo - luz_marco-0300.jpg',
      caption: 'marco_luz photo - luz_marco-0300.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0301.jpg',
      alt: 'marco_luz photo - luz_marco-0301.jpg',
      caption: 'marco_luz photo - luz_marco-0301.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0302.jpg',
      alt: 'marco_luz photo - luz_marco-0302.jpg',
      caption: 'marco_luz photo - luz_marco-0302.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0303.jpg',
      alt: 'marco_luz photo - luz_marco-0303.jpg',
      caption: 'marco_luz photo - luz_marco-0303.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0304.jpg',
      alt: 'marco_luz photo - luz_marco-0304.jpg',
      caption: 'marco_luz photo - luz_marco-0304.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0305.jpg',
      alt: 'marco_luz photo - luz_marco-0305.jpg',
      caption: 'marco_luz photo - luz_marco-0305.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0306.jpg',
      alt: 'marco_luz photo - luz_marco-0306.jpg',
      caption: 'marco_luz photo - luz_marco-0306.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0307.jpg',
      alt: 'marco_luz photo - luz_marco-0307.jpg',
      caption: 'marco_luz photo - luz_marco-0307.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0308.jpg',
      alt: 'marco_luz photo - luz_marco-0308.jpg',
      caption: 'marco_luz photo - luz_marco-0308.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0309.jpg',
      alt: 'marco_luz photo - luz_marco-0309.jpg',
      caption: 'marco_luz photo - luz_marco-0309.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0310.jpg',
      alt: 'marco_luz photo - luz_marco-0310.jpg',
      caption: 'marco_luz photo - luz_marco-0310.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0311.jpg',
      alt: 'marco_luz photo - luz_marco-0311.jpg',
      caption: 'marco_luz photo - luz_marco-0311.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0312.jpg',
      alt: 'marco_luz photo - luz_marco-0312.jpg',
      caption: 'marco_luz photo - luz_marco-0312.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0313.jpg',
      alt: 'marco_luz photo - luz_marco-0313.jpg',
      caption: 'marco_luz photo - luz_marco-0313.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0314.jpg',
      alt: 'marco_luz photo - luz_marco-0314.jpg',
      caption: 'marco_luz photo - luz_marco-0314.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0315.jpg',
      alt: 'marco_luz photo - luz_marco-0315.jpg',
      caption: 'marco_luz photo - luz_marco-0315.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0316.jpg',
      alt: 'marco_luz photo - luz_marco-0316.jpg',
      caption: 'marco_luz photo - luz_marco-0316.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0317.jpg',
      alt: 'marco_luz photo - luz_marco-0317.jpg',
      caption: 'marco_luz photo - luz_marco-0317.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0318.jpg',
      alt: 'marco_luz photo - luz_marco-0318.jpg',
      caption: 'marco_luz photo - luz_marco-0318.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0319.jpg',
      alt: 'marco_luz photo - luz_marco-0319.jpg',
      caption: 'marco_luz photo - luz_marco-0319.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0320.jpg',
      alt: 'marco_luz photo - luz_marco-0320.jpg',
      caption: 'marco_luz photo - luz_marco-0320.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0321.jpg',
      alt: 'marco_luz photo - luz_marco-0321.jpg',
      caption: 'marco_luz photo - luz_marco-0321.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0322.jpg',
      alt: 'marco_luz photo - luz_marco-0322.jpg',
      caption: 'marco_luz photo - luz_marco-0322.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0323.jpg',
      alt: 'marco_luz photo - luz_marco-0323.jpg',
      caption: 'marco_luz photo - luz_marco-0323.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0324.jpg',
      alt: 'marco_luz photo - luz_marco-0324.jpg',
      caption: 'marco_luz photo - luz_marco-0324.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0325.jpg',
      alt: 'marco_luz photo - luz_marco-0325.jpg',
      caption: 'marco_luz photo - luz_marco-0325.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0326.jpg',
      alt: 'marco_luz photo - luz_marco-0326.jpg',
      caption: 'marco_luz photo - luz_marco-0326.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0327.jpg',
      alt: 'marco_luz photo - luz_marco-0327.jpg',
      caption: 'marco_luz photo - luz_marco-0327.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0328.jpg',
      alt: 'marco_luz photo - luz_marco-0328.jpg',
      caption: 'marco_luz photo - luz_marco-0328.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0329.jpg',
      alt: 'marco_luz photo - luz_marco-0329.jpg',
      caption: 'marco_luz photo - luz_marco-0329.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0330.jpg',
      alt: 'marco_luz photo - luz_marco-0330.jpg',
      caption: 'marco_luz photo - luz_marco-0330.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0331.jpg',
      alt: 'marco_luz photo - luz_marco-0331.jpg',
      caption: 'marco_luz photo - luz_marco-0331.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0332.jpg',
      alt: 'marco_luz photo - luz_marco-0332.jpg',
      caption: 'marco_luz photo - luz_marco-0332.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0333.jpg',
      alt: 'marco_luz photo - luz_marco-0333.jpg',
      caption: 'marco_luz photo - luz_marco-0333.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0334.jpg',
      alt: 'marco_luz photo - luz_marco-0334.jpg',
      caption: 'marco_luz photo - luz_marco-0334.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0335.jpg',
      alt: 'marco_luz photo - luz_marco-0335.jpg',
      caption: 'marco_luz photo - luz_marco-0335.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0336.jpg',
      alt: 'marco_luz photo - luz_marco-0336.jpg',
      caption: 'marco_luz photo - luz_marco-0336.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0337.jpg',
      alt: 'marco_luz photo - luz_marco-0337.jpg',
      caption: 'marco_luz photo - luz_marco-0337.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0338.jpg',
      alt: 'marco_luz photo - luz_marco-0338.jpg',
      caption: 'marco_luz photo - luz_marco-0338.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0339.jpg',
      alt: 'marco_luz photo - luz_marco-0339.jpg',
      caption: 'marco_luz photo - luz_marco-0339.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0340.jpg',
      alt: 'marco_luz photo - luz_marco-0340.jpg',
      caption: 'marco_luz photo - luz_marco-0340.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0341.jpg',
      alt: 'marco_luz photo - luz_marco-0341.jpg',
      caption: 'marco_luz photo - luz_marco-0341.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0342.jpg',
      alt: 'marco_luz photo - luz_marco-0342.jpg',
      caption: 'marco_luz photo - luz_marco-0342.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0343.jpg',
      alt: 'marco_luz photo - luz_marco-0343.jpg',
      caption: 'marco_luz photo - luz_marco-0343.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0344.jpg',
      alt: 'marco_luz photo - luz_marco-0344.jpg',
      caption: 'marco_luz photo - luz_marco-0344.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0345.jpg',
      alt: 'marco_luz photo - luz_marco-0345.jpg',
      caption: 'marco_luz photo - luz_marco-0345.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0346.jpg',
      alt: 'marco_luz photo - luz_marco-0346.jpg',
      caption: 'marco_luz photo - luz_marco-0346.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0347.jpg',
      alt: 'marco_luz photo - luz_marco-0347.jpg',
      caption: 'marco_luz photo - luz_marco-0347.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0348.jpg',
      alt: 'marco_luz photo - luz_marco-0348.jpg',
      caption: 'marco_luz photo - luz_marco-0348.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0349.jpg',
      alt: 'marco_luz photo - luz_marco-0349.jpg',
      caption: 'marco_luz photo - luz_marco-0349.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0350.jpg',
      alt: 'marco_luz photo - luz_marco-0350.jpg',
      caption: 'marco_luz photo - luz_marco-0350.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0351.jpg',
      alt: 'marco_luz photo - luz_marco-0351.jpg',
      caption: 'marco_luz photo - luz_marco-0351.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0352.jpg',
      alt: 'marco_luz photo - luz_marco-0352.jpg',
      caption: 'marco_luz photo - luz_marco-0352.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0353.jpg',
      alt: 'marco_luz photo - luz_marco-0353.jpg',
      caption: 'marco_luz photo - luz_marco-0353.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0354.jpg',
      alt: 'marco_luz photo - luz_marco-0354.jpg',
      caption: 'marco_luz photo - luz_marco-0354.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0355.jpg',
      alt: 'marco_luz photo - luz_marco-0355.jpg',
      caption: 'marco_luz photo - luz_marco-0355.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0356.jpg',
      alt: 'marco_luz photo - luz_marco-0356.jpg',
      caption: 'marco_luz photo - luz_marco-0356.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0357.jpg',
      alt: 'marco_luz photo - luz_marco-0357.jpg',
      caption: 'marco_luz photo - luz_marco-0357.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0358.jpg',
      alt: 'marco_luz photo - luz_marco-0358.jpg',
      caption: 'marco_luz photo - luz_marco-0358.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0359.jpg',
      alt: 'marco_luz photo - luz_marco-0359.jpg',
      caption: 'marco_luz photo - luz_marco-0359.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0360.jpg',
      alt: 'marco_luz photo - luz_marco-0360.jpg',
      caption: 'marco_luz photo - luz_marco-0360.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0361.jpg',
      alt: 'marco_luz photo - luz_marco-0361.jpg',
      caption: 'marco_luz photo - luz_marco-0361.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0362.jpg',
      alt: 'marco_luz photo - luz_marco-0362.jpg',
      caption: 'marco_luz photo - luz_marco-0362.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0363.jpg',
      alt: 'marco_luz photo - luz_marco-0363.jpg',
      caption: 'marco_luz photo - luz_marco-0363.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0364.jpg',
      alt: 'marco_luz photo - luz_marco-0364.jpg',
      caption: 'marco_luz photo - luz_marco-0364.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0365.jpg',
      alt: 'marco_luz photo - luz_marco-0365.jpg',
      caption: 'marco_luz photo - luz_marco-0365.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0366.jpg',
      alt: 'marco_luz photo - luz_marco-0366.jpg',
      caption: 'marco_luz photo - luz_marco-0366.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0367.jpg',
      alt: 'marco_luz photo - luz_marco-0367.jpg',
      caption: 'marco_luz photo - luz_marco-0367.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0368.jpg',
      alt: 'marco_luz photo - luz_marco-0368.jpg',
      caption: 'marco_luz photo - luz_marco-0368.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0369.jpg',
      alt: 'marco_luz photo - luz_marco-0369.jpg',
      caption: 'marco_luz photo - luz_marco-0369.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0370.jpg',
      alt: 'marco_luz photo - luz_marco-0370.jpg',
      caption: 'marco_luz photo - luz_marco-0370.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0371.jpg',
      alt: 'marco_luz photo - luz_marco-0371.jpg',
      caption: 'marco_luz photo - luz_marco-0371.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0372.jpg',
      alt: 'marco_luz photo - luz_marco-0372.jpg',
      caption: 'marco_luz photo - luz_marco-0372.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0373.jpg',
      alt: 'marco_luz photo - luz_marco-0373.jpg',
      caption: 'marco_luz photo - luz_marco-0373.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0374.jpg',
      alt: 'marco_luz photo - luz_marco-0374.jpg',
      caption: 'marco_luz photo - luz_marco-0374.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0375.jpg',
      alt: 'marco_luz photo - luz_marco-0375.jpg',
      caption: 'marco_luz photo - luz_marco-0375.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0376.jpg',
      alt: 'marco_luz photo - luz_marco-0376.jpg',
      caption: 'marco_luz photo - luz_marco-0376.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0377.jpg',
      alt: 'marco_luz photo - luz_marco-0377.jpg',
      caption: 'marco_luz photo - luz_marco-0377.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0378.jpg',
      alt: 'marco_luz photo - luz_marco-0378.jpg',
      caption: 'marco_luz photo - luz_marco-0378.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0379.jpg',
      alt: 'marco_luz photo - luz_marco-0379.jpg',
      caption: 'marco_luz photo - luz_marco-0379.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0380.jpg',
      alt: 'marco_luz photo - luz_marco-0380.jpg',
      caption: 'marco_luz photo - luz_marco-0380.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0381.jpg',
      alt: 'marco_luz photo - luz_marco-0381.jpg',
      caption: 'marco_luz photo - luz_marco-0381.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0382.jpg',
      alt: 'marco_luz photo - luz_marco-0382.jpg',
      caption: 'marco_luz photo - luz_marco-0382.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0383.jpg',
      alt: 'marco_luz photo - luz_marco-0383.jpg',
      caption: 'marco_luz photo - luz_marco-0383.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0384.jpg',
      alt: 'marco_luz photo - luz_marco-0384.jpg',
      caption: 'marco_luz photo - luz_marco-0384.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0385.jpg',
      alt: 'marco_luz photo - luz_marco-0385.jpg',
      caption: 'marco_luz photo - luz_marco-0385.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0386.jpg',
      alt: 'marco_luz photo - luz_marco-0386.jpg',
      caption: 'marco_luz photo - luz_marco-0386.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0387.jpg',
      alt: 'marco_luz photo - luz_marco-0387.jpg',
      caption: 'marco_luz photo - luz_marco-0387.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0388.jpg',
      alt: 'marco_luz photo - luz_marco-0388.jpg',
      caption: 'marco_luz photo - luz_marco-0388.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0389.jpg',
      alt: 'marco_luz photo - luz_marco-0389.jpg',
      caption: 'marco_luz photo - luz_marco-0389.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0390.jpg',
      alt: 'marco_luz photo - luz_marco-0390.jpg',
      caption: 'marco_luz photo - luz_marco-0390.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0391.jpg',
      alt: 'marco_luz photo - luz_marco-0391.jpg',
      caption: 'marco_luz photo - luz_marco-0391.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0392.jpg',
      alt: 'marco_luz photo - luz_marco-0392.jpg',
      caption: 'marco_luz photo - luz_marco-0392.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0393.jpg',
      alt: 'marco_luz photo - luz_marco-0393.jpg',
      caption: 'marco_luz photo - luz_marco-0393.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0394.jpg',
      alt: 'marco_luz photo - luz_marco-0394.jpg',
      caption: 'marco_luz photo - luz_marco-0394.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0395.jpg',
      alt: 'marco_luz photo - luz_marco-0395.jpg',
      caption: 'marco_luz photo - luz_marco-0395.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0396.jpg',
      alt: 'marco_luz photo - luz_marco-0396.jpg',
      caption: 'marco_luz photo - luz_marco-0396.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0397.jpg',
      alt: 'marco_luz photo - luz_marco-0397.jpg',
      caption: 'marco_luz photo - luz_marco-0397.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0398.jpg',
      alt: 'marco_luz photo - luz_marco-0398.jpg',
      caption: 'marco_luz photo - luz_marco-0398.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0399.jpg',
      alt: 'marco_luz photo - luz_marco-0399.jpg',
      caption: 'marco_luz photo - luz_marco-0399.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0400.jpg',
      alt: 'marco_luz photo - luz_marco-0400.jpg',
      caption: 'marco_luz photo - luz_marco-0400.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0401.jpg',
      alt: 'marco_luz photo - luz_marco-0401.jpg',
      caption: 'marco_luz photo - luz_marco-0401.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0402.jpg',
      alt: 'marco_luz photo - luz_marco-0402.jpg',
      caption: 'marco_luz photo - luz_marco-0402.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0403.jpg',
      alt: 'marco_luz photo - luz_marco-0403.jpg',
      caption: 'marco_luz photo - luz_marco-0403.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0404.jpg',
      alt: 'marco_luz photo - luz_marco-0404.jpg',
      caption: 'marco_luz photo - luz_marco-0404.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0405.jpg',
      alt: 'marco_luz photo - luz_marco-0405.jpg',
      caption: 'marco_luz photo - luz_marco-0405.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0406.jpg',
      alt: 'marco_luz photo - luz_marco-0406.jpg',
      caption: 'marco_luz photo - luz_marco-0406.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0407.jpg',
      alt: 'marco_luz photo - luz_marco-0407.jpg',
      caption: 'marco_luz photo - luz_marco-0407.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0408.jpg',
      alt: 'marco_luz photo - luz_marco-0408.jpg',
      caption: 'marco_luz photo - luz_marco-0408.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0409.jpg',
      alt: 'marco_luz photo - luz_marco-0409.jpg',
      caption: 'marco_luz photo - luz_marco-0409.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0410.jpg',
      alt: 'marco_luz photo - luz_marco-0410.jpg',
      caption: 'marco_luz photo - luz_marco-0410.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0411.jpg',
      alt: 'marco_luz photo - luz_marco-0411.jpg',
      caption: 'marco_luz photo - luz_marco-0411.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0412.jpg',
      alt: 'marco_luz photo - luz_marco-0412.jpg',
      caption: 'marco_luz photo - luz_marco-0412.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0413.jpg',
      alt: 'marco_luz photo - luz_marco-0413.jpg',
      caption: 'marco_luz photo - luz_marco-0413.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0414.jpg',
      alt: 'marco_luz photo - luz_marco-0414.jpg',
      caption: 'marco_luz photo - luz_marco-0414.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0415.jpg',
      alt: 'marco_luz photo - luz_marco-0415.jpg',
      caption: 'marco_luz photo - luz_marco-0415.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0416.jpg',
      alt: 'marco_luz photo - luz_marco-0416.jpg',
      caption: 'marco_luz photo - luz_marco-0416.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0417.jpg',
      alt: 'marco_luz photo - luz_marco-0417.jpg',
      caption: 'marco_luz photo - luz_marco-0417.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0418.jpg',
      alt: 'marco_luz photo - luz_marco-0418.jpg',
      caption: 'marco_luz photo - luz_marco-0418.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0419.jpg',
      alt: 'marco_luz photo - luz_marco-0419.jpg',
      caption: 'marco_luz photo - luz_marco-0419.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0420.jpg',
      alt: 'marco_luz photo - luz_marco-0420.jpg',
      caption: 'marco_luz photo - luz_marco-0420.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0421.jpg',
      alt: 'marco_luz photo - luz_marco-0421.jpg',
      caption: 'marco_luz photo - luz_marco-0421.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0423.jpg',
      alt: 'marco_luz photo - luz_marco-0423.jpg',
      caption: 'marco_luz photo - luz_marco-0423.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0424.jpg',
      alt: 'marco_luz photo - luz_marco-0424.jpg',
      caption: 'marco_luz photo - luz_marco-0424.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0425.jpg',
      alt: 'marco_luz photo - luz_marco-0425.jpg',
      caption: 'marco_luz photo - luz_marco-0425.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0426.jpg',
      alt: 'marco_luz photo - luz_marco-0426.jpg',
      caption: 'marco_luz photo - luz_marco-0426.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0427.jpg',
      alt: 'marco_luz photo - luz_marco-0427.jpg',
      caption: 'marco_luz photo - luz_marco-0427.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0428.jpg',
      alt: 'marco_luz photo - luz_marco-0428.jpg',
      caption: 'marco_luz photo - luz_marco-0428.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0429.jpg',
      alt: 'marco_luz photo - luz_marco-0429.jpg',
      caption: 'marco_luz photo - luz_marco-0429.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0430.jpg',
      alt: 'marco_luz photo - luz_marco-0430.jpg',
      caption: 'marco_luz photo - luz_marco-0430.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0431.jpg',
      alt: 'marco_luz photo - luz_marco-0431.jpg',
      caption: 'marco_luz photo - luz_marco-0431.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0433.jpg',
      alt: 'marco_luz photo - luz_marco-0433.jpg',
      caption: 'marco_luz photo - luz_marco-0433.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0434.jpg',
      alt: 'marco_luz photo - luz_marco-0434.jpg',
      caption: 'marco_luz photo - luz_marco-0434.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0435.jpg',
      alt: 'marco_luz photo - luz_marco-0435.jpg',
      caption: 'marco_luz photo - luz_marco-0435.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0437.jpg',
      alt: 'marco_luz photo - luz_marco-0437.jpg',
      caption: 'marco_luz photo - luz_marco-0437.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0438.jpg',
      alt: 'marco_luz photo - luz_marco-0438.jpg',
      caption: 'marco_luz photo - luz_marco-0438.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0439.jpg',
      alt: 'marco_luz photo - luz_marco-0439.jpg',
      caption: 'marco_luz photo - luz_marco-0439.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0440.jpg',
      alt: 'marco_luz photo - luz_marco-0440.jpg',
      caption: 'marco_luz photo - luz_marco-0440.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0441.jpg',
      alt: 'marco_luz photo - luz_marco-0441.jpg',
      caption: 'marco_luz photo - luz_marco-0441.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0442.jpg',
      alt: 'marco_luz photo - luz_marco-0442.jpg',
      caption: 'marco_luz photo - luz_marco-0442.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0443.jpg',
      alt: 'marco_luz photo - luz_marco-0443.jpg',
      caption: 'marco_luz photo - luz_marco-0443.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0444.jpg',
      alt: 'marco_luz photo - luz_marco-0444.jpg',
      caption: 'marco_luz photo - luz_marco-0444.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0445.jpg',
      alt: 'marco_luz photo - luz_marco-0445.jpg',
      caption: 'marco_luz photo - luz_marco-0445.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0446.jpg',
      alt: 'marco_luz photo - luz_marco-0446.jpg',
      caption: 'marco_luz photo - luz_marco-0446.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0447.jpg',
      alt: 'marco_luz photo - luz_marco-0447.jpg',
      caption: 'marco_luz photo - luz_marco-0447.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0448.jpg',
      alt: 'marco_luz photo - luz_marco-0448.jpg',
      caption: 'marco_luz photo - luz_marco-0448.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0449.jpg',
      alt: 'marco_luz photo - luz_marco-0449.jpg',
      caption: 'marco_luz photo - luz_marco-0449.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0450.jpg',
      alt: 'marco_luz photo - luz_marco-0450.jpg',
      caption: 'marco_luz photo - luz_marco-0450.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0451.jpg',
      alt: 'marco_luz photo - luz_marco-0451.jpg',
      caption: 'marco_luz photo - luz_marco-0451.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0452.jpg',
      alt: 'marco_luz photo - luz_marco-0452.jpg',
      caption: 'marco_luz photo - luz_marco-0452.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0453.jpg',
      alt: 'marco_luz photo - luz_marco-0453.jpg',
      caption: 'marco_luz photo - luz_marco-0453.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0454.jpg',
      alt: 'marco_luz photo - luz_marco-0454.jpg',
      caption: 'marco_luz photo - luz_marco-0454.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0455.jpg',
      alt: 'marco_luz photo - luz_marco-0455.jpg',
      caption: 'marco_luz photo - luz_marco-0455.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0456.jpg',
      alt: 'marco_luz photo - luz_marco-0456.jpg',
      caption: 'marco_luz photo - luz_marco-0456.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0457.jpg',
      alt: 'marco_luz photo - luz_marco-0457.jpg',
      caption: 'marco_luz photo - luz_marco-0457.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0458.jpg',
      alt: 'marco_luz photo - luz_marco-0458.jpg',
      caption: 'marco_luz photo - luz_marco-0458.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0459.jpg',
      alt: 'marco_luz photo - luz_marco-0459.jpg',
      caption: 'marco_luz photo - luz_marco-0459.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0460.jpg',
      alt: 'marco_luz photo - luz_marco-0460.jpg',
      caption: 'marco_luz photo - luz_marco-0460.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0461.jpg',
      alt: 'marco_luz photo - luz_marco-0461.jpg',
      caption: 'marco_luz photo - luz_marco-0461.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0462.jpg',
      alt: 'marco_luz photo - luz_marco-0462.jpg',
      caption: 'marco_luz photo - luz_marco-0462.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0463.jpg',
      alt: 'marco_luz photo - luz_marco-0463.jpg',
      caption: 'marco_luz photo - luz_marco-0463.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0464.jpg',
      alt: 'marco_luz photo - luz_marco-0464.jpg',
      caption: 'marco_luz photo - luz_marco-0464.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0465.jpg',
      alt: 'marco_luz photo - luz_marco-0465.jpg',
      caption: 'marco_luz photo - luz_marco-0465.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0466.jpg',
      alt: 'marco_luz photo - luz_marco-0466.jpg',
      caption: 'marco_luz photo - luz_marco-0466.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0467.jpg',
      alt: 'marco_luz photo - luz_marco-0467.jpg',
      caption: 'marco_luz photo - luz_marco-0467.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0468.jpg',
      alt: 'marco_luz photo - luz_marco-0468.jpg',
      caption: 'marco_luz photo - luz_marco-0468.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0469.jpg',
      alt: 'marco_luz photo - luz_marco-0469.jpg',
      caption: 'marco_luz photo - luz_marco-0469.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0470.jpg',
      alt: 'marco_luz photo - luz_marco-0470.jpg',
      caption: 'marco_luz photo - luz_marco-0470.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0471.jpg',
      alt: 'marco_luz photo - luz_marco-0471.jpg',
      caption: 'marco_luz photo - luz_marco-0471.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0472.jpg',
      alt: 'marco_luz photo - luz_marco-0472.jpg',
      caption: 'marco_luz photo - luz_marco-0472.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0473.jpg',
      alt: 'marco_luz photo - luz_marco-0473.jpg',
      caption: 'marco_luz photo - luz_marco-0473.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0474.jpg',
      alt: 'marco_luz photo - luz_marco-0474.jpg',
      caption: 'marco_luz photo - luz_marco-0474.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0475.jpg',
      alt: 'marco_luz photo - luz_marco-0475.jpg',
      caption: 'marco_luz photo - luz_marco-0475.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0476.jpg',
      alt: 'marco_luz photo - luz_marco-0476.jpg',
      caption: 'marco_luz photo - luz_marco-0476.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0477.jpg',
      alt: 'marco_luz photo - luz_marco-0477.jpg',
      caption: 'marco_luz photo - luz_marco-0477.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0478.jpg',
      alt: 'marco_luz photo - luz_marco-0478.jpg',
      caption: 'marco_luz photo - luz_marco-0478.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0479.jpg',
      alt: 'marco_luz photo - luz_marco-0479.jpg',
      caption: 'marco_luz photo - luz_marco-0479.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0480.jpg',
      alt: 'marco_luz photo - luz_marco-0480.jpg',
      caption: 'marco_luz photo - luz_marco-0480.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0481.jpg',
      alt: 'marco_luz photo - luz_marco-0481.jpg',
      caption: 'marco_luz photo - luz_marco-0481.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0482.jpg',
      alt: 'marco_luz photo - luz_marco-0482.jpg',
      caption: 'marco_luz photo - luz_marco-0482.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0483.jpg',
      alt: 'marco_luz photo - luz_marco-0483.jpg',
      caption: 'marco_luz photo - luz_marco-0483.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0484.jpg',
      alt: 'marco_luz photo - luz_marco-0484.jpg',
      caption: 'marco_luz photo - luz_marco-0484.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0485.jpg',
      alt: 'marco_luz photo - luz_marco-0485.jpg',
      caption: 'marco_luz photo - luz_marco-0485.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0486.jpg',
      alt: 'marco_luz photo - luz_marco-0486.jpg',
      caption: 'marco_luz photo - luz_marco-0486.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0487.jpg',
      alt: 'marco_luz photo - luz_marco-0487.jpg',
      caption: 'marco_luz photo - luz_marco-0487.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0488.jpg',
      alt: 'marco_luz photo - luz_marco-0488.jpg',
      caption: 'marco_luz photo - luz_marco-0488.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0489.jpg',
      alt: 'marco_luz photo - luz_marco-0489.jpg',
      caption: 'marco_luz photo - luz_marco-0489.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0490.jpg',
      alt: 'marco_luz photo - luz_marco-0490.jpg',
      caption: 'marco_luz photo - luz_marco-0490.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0491.jpg',
      alt: 'marco_luz photo - luz_marco-0491.jpg',
      caption: 'marco_luz photo - luz_marco-0491.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0492.jpg',
      alt: 'marco_luz photo - luz_marco-0492.jpg',
      caption: 'marco_luz photo - luz_marco-0492.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0493.jpg',
      alt: 'marco_luz photo - luz_marco-0493.jpg',
      caption: 'marco_luz photo - luz_marco-0493.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0494.jpg',
      alt: 'marco_luz photo - luz_marco-0494.jpg',
      caption: 'marco_luz photo - luz_marco-0494.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0495.jpg',
      alt: 'marco_luz photo - luz_marco-0495.jpg',
      caption: 'marco_luz photo - luz_marco-0495.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0496.jpg',
      alt: 'marco_luz photo - luz_marco-0496.jpg',
      caption: 'marco_luz photo - luz_marco-0496.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0497.jpg',
      alt: 'marco_luz photo - luz_marco-0497.jpg',
      caption: 'marco_luz photo - luz_marco-0497.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0498.jpg',
      alt: 'marco_luz photo - luz_marco-0498.jpg',
      caption: 'marco_luz photo - luz_marco-0498.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0499.jpg',
      alt: 'marco_luz photo - luz_marco-0499.jpg',
      caption: 'marco_luz photo - luz_marco-0499.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0500.jpg',
      alt: 'marco_luz photo - luz_marco-0500.jpg',
      caption: 'marco_luz photo - luz_marco-0500.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0501.jpg',
      alt: 'marco_luz photo - luz_marco-0501.jpg',
      caption: 'marco_luz photo - luz_marco-0501.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0502.jpg',
      alt: 'marco_luz photo - luz_marco-0502.jpg',
      caption: 'marco_luz photo - luz_marco-0502.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0503.jpg',
      alt: 'marco_luz photo - luz_marco-0503.jpg',
      caption: 'marco_luz photo - luz_marco-0503.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0504.jpg',
      alt: 'marco_luz photo - luz_marco-0504.jpg',
      caption: 'marco_luz photo - luz_marco-0504.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0505.jpg',
      alt: 'marco_luz photo - luz_marco-0505.jpg',
      caption: 'marco_luz photo - luz_marco-0505.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0506.jpg',
      alt: 'marco_luz photo - luz_marco-0506.jpg',
      caption: 'marco_luz photo - luz_marco-0506.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0507.jpg',
      alt: 'marco_luz photo - luz_marco-0507.jpg',
      caption: 'marco_luz photo - luz_marco-0507.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0508.jpg',
      alt: 'marco_luz photo - luz_marco-0508.jpg',
      caption: 'marco_luz photo - luz_marco-0508.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0509.jpg',
      alt: 'marco_luz photo - luz_marco-0509.jpg',
      caption: 'marco_luz photo - luz_marco-0509.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0510.jpg',
      alt: 'marco_luz photo - luz_marco-0510.jpg',
      caption: 'marco_luz photo - luz_marco-0510.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0511.jpg',
      alt: 'marco_luz photo - luz_marco-0511.jpg',
      caption: 'marco_luz photo - luz_marco-0511.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0512.jpg',
      alt: 'marco_luz photo - luz_marco-0512.jpg',
      caption: 'marco_luz photo - luz_marco-0512.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0513.jpg',
      alt: 'marco_luz photo - luz_marco-0513.jpg',
      caption: 'marco_luz photo - luz_marco-0513.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0514.jpg',
      alt: 'marco_luz photo - luz_marco-0514.jpg',
      caption: 'marco_luz photo - luz_marco-0514.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0515.jpg',
      alt: 'marco_luz photo - luz_marco-0515.jpg',
      caption: 'marco_luz photo - luz_marco-0515.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0516.jpg',
      alt: 'marco_luz photo - luz_marco-0516.jpg',
      caption: 'marco_luz photo - luz_marco-0516.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0517.jpg',
      alt: 'marco_luz photo - luz_marco-0517.jpg',
      caption: 'marco_luz photo - luz_marco-0517.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0518.jpg',
      alt: 'marco_luz photo - luz_marco-0518.jpg',
      caption: 'marco_luz photo - luz_marco-0518.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0519.jpg',
      alt: 'marco_luz photo - luz_marco-0519.jpg',
      caption: 'marco_luz photo - luz_marco-0519.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0520.jpg',
      alt: 'marco_luz photo - luz_marco-0520.jpg',
      caption: 'marco_luz photo - luz_marco-0520.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0521.jpg',
      alt: 'marco_luz photo - luz_marco-0521.jpg',
      caption: 'marco_luz photo - luz_marco-0521.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0522.jpg',
      alt: 'marco_luz photo - luz_marco-0522.jpg',
      caption: 'marco_luz photo - luz_marco-0522.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0523.jpg',
      alt: 'marco_luz photo - luz_marco-0523.jpg',
      caption: 'marco_luz photo - luz_marco-0523.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0524.jpg',
      alt: 'marco_luz photo - luz_marco-0524.jpg',
      caption: 'marco_luz photo - luz_marco-0524.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0525.jpg',
      alt: 'marco_luz photo - luz_marco-0525.jpg',
      caption: 'marco_luz photo - luz_marco-0525.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0526.jpg',
      alt: 'marco_luz photo - luz_marco-0526.jpg',
      caption: 'marco_luz photo - luz_marco-0526.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0527.jpg',
      alt: 'marco_luz photo - luz_marco-0527.jpg',
      caption: 'marco_luz photo - luz_marco-0527.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0528.jpg',
      alt: 'marco_luz photo - luz_marco-0528.jpg',
      caption: 'marco_luz photo - luz_marco-0528.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0529.jpg',
      alt: 'marco_luz photo - luz_marco-0529.jpg',
      caption: 'marco_luz photo - luz_marco-0529.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0530.jpg',
      alt: 'marco_luz photo - luz_marco-0530.jpg',
      caption: 'marco_luz photo - luz_marco-0530.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0531.jpg',
      alt: 'marco_luz photo - luz_marco-0531.jpg',
      caption: 'marco_luz photo - luz_marco-0531.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0532.jpg',
      alt: 'marco_luz photo - luz_marco-0532.jpg',
      caption: 'marco_luz photo - luz_marco-0532.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0533.jpg',
      alt: 'marco_luz photo - luz_marco-0533.jpg',
      caption: 'marco_luz photo - luz_marco-0533.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0534.jpg',
      alt: 'marco_luz photo - luz_marco-0534.jpg',
      caption: 'marco_luz photo - luz_marco-0534.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0535.jpg',
      alt: 'marco_luz photo - luz_marco-0535.jpg',
      caption: 'marco_luz photo - luz_marco-0535.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0536.jpg',
      alt: 'marco_luz photo - luz_marco-0536.jpg',
      caption: 'marco_luz photo - luz_marco-0536.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0537.jpg',
      alt: 'marco_luz photo - luz_marco-0537.jpg',
      caption: 'marco_luz photo - luz_marco-0537.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0538.jpg',
      alt: 'marco_luz photo - luz_marco-0538.jpg',
      caption: 'marco_luz photo - luz_marco-0538.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0539.jpg',
      alt: 'marco_luz photo - luz_marco-0539.jpg',
      caption: 'marco_luz photo - luz_marco-0539.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0540.jpg',
      alt: 'marco_luz photo - luz_marco-0540.jpg',
      caption: 'marco_luz photo - luz_marco-0540.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0541.jpg',
      alt: 'marco_luz photo - luz_marco-0541.jpg',
      caption: 'marco_luz photo - luz_marco-0541.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0542.jpg',
      alt: 'marco_luz photo - luz_marco-0542.jpg',
      caption: 'marco_luz photo - luz_marco-0542.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0543.jpg',
      alt: 'marco_luz photo - luz_marco-0543.jpg',
      caption: 'marco_luz photo - luz_marco-0543.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0544.jpg',
      alt: 'marco_luz photo - luz_marco-0544.jpg',
      caption: 'marco_luz photo - luz_marco-0544.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0545.jpg',
      alt: 'marco_luz photo - luz_marco-0545.jpg',
      caption: 'marco_luz photo - luz_marco-0545.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0546.jpg',
      alt: 'marco_luz photo - luz_marco-0546.jpg',
      caption: 'marco_luz photo - luz_marco-0546.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0547.jpg',
      alt: 'marco_luz photo - luz_marco-0547.jpg',
      caption: 'marco_luz photo - luz_marco-0547.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0548.jpg',
      alt: 'marco_luz photo - luz_marco-0548.jpg',
      caption: 'marco_luz photo - luz_marco-0548.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0549.jpg',
      alt: 'marco_luz photo - luz_marco-0549.jpg',
      caption: 'marco_luz photo - luz_marco-0549.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0550.jpg',
      alt: 'marco_luz photo - luz_marco-0550.jpg',
      caption: 'marco_luz photo - luz_marco-0550.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0551.jpg',
      alt: 'marco_luz photo - luz_marco-0551.jpg',
      caption: 'marco_luz photo - luz_marco-0551.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0552.jpg',
      alt: 'marco_luz photo - luz_marco-0552.jpg',
      caption: 'marco_luz photo - luz_marco-0552.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0553.jpg',
      alt: 'marco_luz photo - luz_marco-0553.jpg',
      caption: 'marco_luz photo - luz_marco-0553.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0554.jpg',
      alt: 'marco_luz photo - luz_marco-0554.jpg',
      caption: 'marco_luz photo - luz_marco-0554.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0555.jpg',
      alt: 'marco_luz photo - luz_marco-0555.jpg',
      caption: 'marco_luz photo - luz_marco-0555.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0556.jpg',
      alt: 'marco_luz photo - luz_marco-0556.jpg',
      caption: 'marco_luz photo - luz_marco-0556.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0557.jpg',
      alt: 'marco_luz photo - luz_marco-0557.jpg',
      caption: 'marco_luz photo - luz_marco-0557.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0558.jpg',
      alt: 'marco_luz photo - luz_marco-0558.jpg',
      caption: 'marco_luz photo - luz_marco-0558.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0559.jpg',
      alt: 'marco_luz photo - luz_marco-0559.jpg',
      caption: 'marco_luz photo - luz_marco-0559.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0560.jpg',
      alt: 'marco_luz photo - luz_marco-0560.jpg',
      caption: 'marco_luz photo - luz_marco-0560.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0561.jpg',
      alt: 'marco_luz photo - luz_marco-0561.jpg',
      caption: 'marco_luz photo - luz_marco-0561.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0562.jpg',
      alt: 'marco_luz photo - luz_marco-0562.jpg',
      caption: 'marco_luz photo - luz_marco-0562.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0563.jpg',
      alt: 'marco_luz photo - luz_marco-0563.jpg',
      caption: 'marco_luz photo - luz_marco-0563.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0564.jpg',
      alt: 'marco_luz photo - luz_marco-0564.jpg',
      caption: 'marco_luz photo - luz_marco-0564.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0565.jpg',
      alt: 'marco_luz photo - luz_marco-0565.jpg',
      caption: 'marco_luz photo - luz_marco-0565.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0566.jpg',
      alt: 'marco_luz photo - luz_marco-0566.jpg',
      caption: 'marco_luz photo - luz_marco-0566.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0567.jpg',
      alt: 'marco_luz photo - luz_marco-0567.jpg',
      caption: 'marco_luz photo - luz_marco-0567.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0568.jpg',
      alt: 'marco_luz photo - luz_marco-0568.jpg',
      caption: 'marco_luz photo - luz_marco-0568.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0569.jpg',
      alt: 'marco_luz photo - luz_marco-0569.jpg',
      caption: 'marco_luz photo - luz_marco-0569.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0570.jpg',
      alt: 'marco_luz photo - luz_marco-0570.jpg',
      caption: 'marco_luz photo - luz_marco-0570.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0571.jpg',
      alt: 'marco_luz photo - luz_marco-0571.jpg',
      caption: 'marco_luz photo - luz_marco-0571.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0572.jpg',
      alt: 'marco_luz photo - luz_marco-0572.jpg',
      caption: 'marco_luz photo - luz_marco-0572.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0573.jpg',
      alt: 'marco_luz photo - luz_marco-0573.jpg',
      caption: 'marco_luz photo - luz_marco-0573.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0574.jpg',
      alt: 'marco_luz photo - luz_marco-0574.jpg',
      caption: 'marco_luz photo - luz_marco-0574.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0575.jpg',
      alt: 'marco_luz photo - luz_marco-0575.jpg',
      caption: 'marco_luz photo - luz_marco-0575.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0576.jpg',
      alt: 'marco_luz photo - luz_marco-0576.jpg',
      caption: 'marco_luz photo - luz_marco-0576.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0577.jpg',
      alt: 'marco_luz photo - luz_marco-0577.jpg',
      caption: 'marco_luz photo - luz_marco-0577.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0578.jpg',
      alt: 'marco_luz photo - luz_marco-0578.jpg',
      caption: 'marco_luz photo - luz_marco-0578.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0579.jpg',
      alt: 'marco_luz photo - luz_marco-0579.jpg',
      caption: 'marco_luz photo - luz_marco-0579.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0580.jpg',
      alt: 'marco_luz photo - luz_marco-0580.jpg',
      caption: 'marco_luz photo - luz_marco-0580.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0581.jpg',
      alt: 'marco_luz photo - luz_marco-0581.jpg',
      caption: 'marco_luz photo - luz_marco-0581.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0582.jpg',
      alt: 'marco_luz photo - luz_marco-0582.jpg',
      caption: 'marco_luz photo - luz_marco-0582.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0583.jpg',
      alt: 'marco_luz photo - luz_marco-0583.jpg',
      caption: 'marco_luz photo - luz_marco-0583.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0584.jpg',
      alt: 'marco_luz photo - luz_marco-0584.jpg',
      caption: 'marco_luz photo - luz_marco-0584.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0585.jpg',
      alt: 'marco_luz photo - luz_marco-0585.jpg',
      caption: 'marco_luz photo - luz_marco-0585.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0586.jpg',
      alt: 'marco_luz photo - luz_marco-0586.jpg',
      caption: 'marco_luz photo - luz_marco-0586.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0587.jpg',
      alt: 'marco_luz photo - luz_marco-0587.jpg',
      caption: 'marco_luz photo - luz_marco-0587.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0588.jpg',
      alt: 'marco_luz photo - luz_marco-0588.jpg',
      caption: 'marco_luz photo - luz_marco-0588.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0589.jpg',
      alt: 'marco_luz photo - luz_marco-0589.jpg',
      caption: 'marco_luz photo - luz_marco-0589.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0590.jpg',
      alt: 'marco_luz photo - luz_marco-0590.jpg',
      caption: 'marco_luz photo - luz_marco-0590.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0591.jpg',
      alt: 'marco_luz photo - luz_marco-0591.jpg',
      caption: 'marco_luz photo - luz_marco-0591.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0592.jpg',
      alt: 'marco_luz photo - luz_marco-0592.jpg',
      caption: 'marco_luz photo - luz_marco-0592.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0593.jpg',
      alt: 'marco_luz photo - luz_marco-0593.jpg',
      caption: 'marco_luz photo - luz_marco-0593.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0594.jpg',
      alt: 'marco_luz photo - luz_marco-0594.jpg',
      caption: 'marco_luz photo - luz_marco-0594.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0595.jpg',
      alt: 'marco_luz photo - luz_marco-0595.jpg',
      caption: 'marco_luz photo - luz_marco-0595.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0596.jpg',
      alt: 'marco_luz photo - luz_marco-0596.jpg',
      caption: 'marco_luz photo - luz_marco-0596.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0597.jpg',
      alt: 'marco_luz photo - luz_marco-0597.jpg',
      caption: 'marco_luz photo - luz_marco-0597.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0598.jpg',
      alt: 'marco_luz photo - luz_marco-0598.jpg',
      caption: 'marco_luz photo - luz_marco-0598.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0599.jpg',
      alt: 'marco_luz photo - luz_marco-0599.jpg',
      caption: 'marco_luz photo - luz_marco-0599.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0600.jpg',
      alt: 'marco_luz photo - luz_marco-0600.jpg',
      caption: 'marco_luz photo - luz_marco-0600.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0601.jpg',
      alt: 'marco_luz photo - luz_marco-0601.jpg',
      caption: 'marco_luz photo - luz_marco-0601.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0602.jpg',
      alt: 'marco_luz photo - luz_marco-0602.jpg',
      caption: 'marco_luz photo - luz_marco-0602.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0603.jpg',
      alt: 'marco_luz photo - luz_marco-0603.jpg',
      caption: 'marco_luz photo - luz_marco-0603.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0604.jpg',
      alt: 'marco_luz photo - luz_marco-0604.jpg',
      caption: 'marco_luz photo - luz_marco-0604.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0605.jpg',
      alt: 'marco_luz photo - luz_marco-0605.jpg',
      caption: 'marco_luz photo - luz_marco-0605.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0606.jpg',
      alt: 'marco_luz photo - luz_marco-0606.jpg',
      caption: 'marco_luz photo - luz_marco-0606.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0607.jpg',
      alt: 'marco_luz photo - luz_marco-0607.jpg',
      caption: 'marco_luz photo - luz_marco-0607.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0608.jpg',
      alt: 'marco_luz photo - luz_marco-0608.jpg',
      caption: 'marco_luz photo - luz_marco-0608.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0609.jpg',
      alt: 'marco_luz photo - luz_marco-0609.jpg',
      caption: 'marco_luz photo - luz_marco-0609.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0610.jpg',
      alt: 'marco_luz photo - luz_marco-0610.jpg',
      caption: 'marco_luz photo - luz_marco-0610.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0611.jpg',
      alt: 'marco_luz photo - luz_marco-0611.jpg',
      caption: 'marco_luz photo - luz_marco-0611.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0612.jpg',
      alt: 'marco_luz photo - luz_marco-0612.jpg',
      caption: 'marco_luz photo - luz_marco-0612.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0613.jpg',
      alt: 'marco_luz photo - luz_marco-0613.jpg',
      caption: 'marco_luz photo - luz_marco-0613.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0614.jpg',
      alt: 'marco_luz photo - luz_marco-0614.jpg',
      caption: 'marco_luz photo - luz_marco-0614.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0615.jpg',
      alt: 'marco_luz photo - luz_marco-0615.jpg',
      caption: 'marco_luz photo - luz_marco-0615.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0616.jpg',
      alt: 'marco_luz photo - luz_marco-0616.jpg',
      caption: 'marco_luz photo - luz_marco-0616.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0617.jpg',
      alt: 'marco_luz photo - luz_marco-0617.jpg',
      caption: 'marco_luz photo - luz_marco-0617.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0618.jpg',
      alt: 'marco_luz photo - luz_marco-0618.jpg',
      caption: 'marco_luz photo - luz_marco-0618.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0619.jpg',
      alt: 'marco_luz photo - luz_marco-0619.jpg',
      caption: 'marco_luz photo - luz_marco-0619.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0620.jpg',
      alt: 'marco_luz photo - luz_marco-0620.jpg',
      caption: 'marco_luz photo - luz_marco-0620.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0621.jpg',
      alt: 'marco_luz photo - luz_marco-0621.jpg',
      caption: 'marco_luz photo - luz_marco-0621.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0622.jpg',
      alt: 'marco_luz photo - luz_marco-0622.jpg',
      caption: 'marco_luz photo - luz_marco-0622.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0623.jpg',
      alt: 'marco_luz photo - luz_marco-0623.jpg',
      caption: 'marco_luz photo - luz_marco-0623.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0624.jpg',
      alt: 'marco_luz photo - luz_marco-0624.jpg',
      caption: 'marco_luz photo - luz_marco-0624.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0625.jpg',
      alt: 'marco_luz photo - luz_marco-0625.jpg',
      caption: 'marco_luz photo - luz_marco-0625.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0626.jpg',
      alt: 'marco_luz photo - luz_marco-0626.jpg',
      caption: 'marco_luz photo - luz_marco-0626.jpg'
    },
    {
      src: '/images/galleries/marco_luz/luz_marco-0627.jpg',
      alt: 'marco_luz photo - luz_marco-0627.jpg',
      caption: 'marco_luz photo - luz_marco-0627.jpg'
    }
  ],
  
  plymouth: [
    {
      src: '/images/galleries/plymouth/IMG_4038.jpg',
      alt: 'plymouth photo - IMG_4038.jpg',
      caption: 'plymouth photo - IMG_4038.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4039.jpg',
      alt: 'plymouth photo - IMG_4039.jpg',
      caption: 'plymouth photo - IMG_4039.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4040.jpg',
      alt: 'plymouth photo - IMG_4040.jpg',
      caption: 'plymouth photo - IMG_4040.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4041.jpg',
      alt: 'plymouth photo - IMG_4041.jpg',
      caption: 'plymouth photo - IMG_4041.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4042.jpg',
      alt: 'plymouth photo - IMG_4042.jpg',
      caption: 'plymouth photo - IMG_4042.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4043.jpg',
      alt: 'plymouth photo - IMG_4043.jpg',
      caption: 'plymouth photo - IMG_4043.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4044.jpg',
      alt: 'plymouth photo - IMG_4044.jpg',
      caption: 'plymouth photo - IMG_4044.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4045.jpg',
      alt: 'plymouth photo - IMG_4045.jpg',
      caption: 'plymouth photo - IMG_4045.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4046.jpg',
      alt: 'plymouth photo - IMG_4046.jpg',
      caption: 'plymouth photo - IMG_4046.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4047.jpg',
      alt: 'plymouth photo - IMG_4047.jpg',
      caption: 'plymouth photo - IMG_4047.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4048.jpg',
      alt: 'plymouth photo - IMG_4048.jpg',
      caption: 'plymouth photo - IMG_4048.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4049.jpg',
      alt: 'plymouth photo - IMG_4049.jpg',
      caption: 'plymouth photo - IMG_4049.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4050.jpg',
      alt: 'plymouth photo - IMG_4050.jpg',
      caption: 'plymouth photo - IMG_4050.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4051.jpg',
      alt: 'plymouth photo - IMG_4051.jpg',
      caption: 'plymouth photo - IMG_4051.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4052.jpg',
      alt: 'plymouth photo - IMG_4052.jpg',
      caption: 'plymouth photo - IMG_4052.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4053.jpg',
      alt: 'plymouth photo - IMG_4053.jpg',
      caption: 'plymouth photo - IMG_4053.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_4054.jpg',
      alt: 'plymouth photo - IMG_4054.jpg',
      caption: 'plymouth photo - IMG_4054.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_9253.jpg',
      alt: 'plymouth photo - IMG_9253.jpg',
      caption: 'plymouth photo - IMG_9253.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_9254.jpg',
      alt: 'plymouth photo - IMG_9254.jpg',
      caption: 'plymouth photo - IMG_9254.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_9255.jpg',
      alt: 'plymouth photo - IMG_9255.jpg',
      caption: 'plymouth photo - IMG_9255.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_9256.jpg',
      alt: 'plymouth photo - IMG_9256.jpg',
      caption: 'plymouth photo - IMG_9256.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_9257.jpg',
      alt: 'plymouth photo - IMG_9257.jpg',
      caption: 'plymouth photo - IMG_9257.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_9258.jpg',
      alt: 'plymouth photo - IMG_9258.jpg',
      caption: 'plymouth photo - IMG_9258.jpg'
    },
    {
      src: '/images/galleries/plymouth/IMG_9259.jpg',
      alt: 'plymouth photo - IMG_9259.jpg',
      caption: 'plymouth photo - IMG_9259.jpg'
    }
  ],
  
  rawrock: [
    {
      src: '/images/galleries/rawrock/DCFC0002.JPG',
      alt: 'rawrock photo - DCFC0002.JPG',
      caption: 'rawrock photo - DCFC0002.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0004.JPG',
      alt: 'rawrock photo - DCFC0004.JPG',
      caption: 'rawrock photo - DCFC0004.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0005.JPG',
      alt: 'rawrock photo - DCFC0005.JPG',
      caption: 'rawrock photo - DCFC0005.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0007.JPG',
      alt: 'rawrock photo - DCFC0007.JPG',
      caption: 'rawrock photo - DCFC0007.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0008.JPG',
      alt: 'rawrock photo - DCFC0008.JPG',
      caption: 'rawrock photo - DCFC0008.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0049.JPG',
      alt: 'rawrock photo - DCFC0049.JPG',
      caption: 'rawrock photo - DCFC0049.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0051.JPG',
      alt: 'rawrock photo - DCFC0051.JPG',
      caption: 'rawrock photo - DCFC0051.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0052.JPG',
      alt: 'rawrock photo - DCFC0052.JPG',
      caption: 'rawrock photo - DCFC0052.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0053.JPG',
      alt: 'rawrock photo - DCFC0053.JPG',
      caption: 'rawrock photo - DCFC0053.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0054.JPG',
      alt: 'rawrock photo - DCFC0054.JPG',
      caption: 'rawrock photo - DCFC0054.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0055.JPG',
      alt: 'rawrock photo - DCFC0055.JPG',
      caption: 'rawrock photo - DCFC0055.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0057.JPG',
      alt: 'rawrock photo - DCFC0057.JPG',
      caption: 'rawrock photo - DCFC0057.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0058.JPG',
      alt: 'rawrock photo - DCFC0058.JPG',
      caption: 'rawrock photo - DCFC0058.JPG'
    },
    {
      src: '/images/galleries/rawrock/DCFC0059.JPG',
      alt: 'rawrock photo - DCFC0059.JPG',
      caption: 'rawrock photo - DCFC0059.JPG'
    },
    {
      src: '/images/galleries/rawrock/rawrock.jpg',
      alt: 'rawrock photo - rawrock.jpg',
      caption: 'rawrock photo - rawrock.jpg'
    }
  ],
  
  wine: [
    {
      src: '/images/galleries/wine/Angela_50_wine.jpg',
      alt: 'wine photo - Angela_50_wine.jpg',
      caption: 'wine photo - Angela_50_wine.jpg'
    },
    {
      src: '/images/galleries/wine/BlackWhite.jpg',
      alt: 'wine photo - BlackWhite.jpg',
      caption: 'wine photo - BlackWhite.jpg'
    },
    {
      src: '/images/galleries/wine/Color.jpg',
      alt: 'wine photo - Color.jpg',
      caption: 'wine photo - Color.jpg'
    },
    {
      src: '/images/galleries/wine/DeMarco_WineROSE_Label.jpg',
      alt: 'wine photo - DeMarco_WineROSE_Label.jpg',
      caption: 'wine photo - DeMarco_WineROSE_Label.jpg'
    },
    {
      src: '/images/galleries/wine/DeMarco_Wine_Label_2019.jpg',
      alt: 'wine photo - DeMarco_Wine_Label_2019.jpg',
      caption: 'wine photo - DeMarco_Wine_Label_2019.jpg'
    },
    {
      src: '/images/galleries/wine/DuoTone2020.jpg',
      alt: 'wine photo - DuoTone2020.jpg',
      caption: 'wine photo - DuoTone2020.jpg'
    },
    {
      src: '/images/galleries/wine/HappyHolidays.png',
      alt: 'wine photo - HappyHolidays.png',
      caption: 'wine photo - HappyHolidays.png'
    },
    {
      src: '/images/galleries/wine/IMG_0620.JPG',
      alt: 'wine photo - IMG_0620.JPG',
      caption: 'wine photo - IMG_0620.JPG'
    },
    {
      src: '/images/galleries/wine/IMG_0622.JPG',
      alt: 'wine photo - IMG_0622.JPG',
      caption: 'wine photo - IMG_0622.JPG'
    },
    {
      src: '/images/galleries/wine/IMG_0625.PNG',
      alt: 'wine photo - IMG_0625.PNG',
      caption: 'wine photo - IMG_0625.PNG'
    },
    {
      src: '/images/galleries/wine/IMG_0626.PNG',
      alt: 'wine photo - IMG_0626.PNG',
      caption: 'wine photo - IMG_0626.PNG'
    },
    {
      src: '/images/galleries/wine/IMG_0627.PNG',
      alt: 'wine photo - IMG_0627.PNG',
      caption: 'wine photo - IMG_0627.PNG'
    },
    {
      src: '/images/galleries/wine/IMG_0628.JPG',
      alt: 'wine photo - IMG_0628.JPG',
      caption: 'wine photo - IMG_0628.JPG'
    },
    {
      src: '/images/galleries/wine/wine_1.jpg',
      alt: 'wine photo - wine_1.jpg',
      caption: 'wine photo - wine_1.jpg'
    },
    {
      src: '/images/galleries/wine/wine_2.jpg',
      alt: 'wine photo - wine_2.jpg',
      caption: 'wine photo - wine_2.jpg'
    },
    {
      src: '/images/galleries/wine/wine_3.jpg',
      alt: 'wine photo - wine_3.jpg',
      caption: 'wine photo - wine_3.jpg'
    },
    {
      src: '/images/galleries/wine/wine_4.jpg',
      alt: 'wine photo - wine_4.jpg',
      caption: 'wine photo - wine_4.jpg'
    }
  ]
};

// For local images, use this format instead:
// {
//   src: '/images/galleries/apple/apple1.jpg',
//   alt: 'Description of image',
//   caption: 'Caption for the image'
// }
